var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _g3, _path11, _path12, _path13, _path14, _g4, _path15, _g5, _path16, _g6, _g7, _g8, _path17, _path18, _g9, _path19, _path20, _path21, _g10, _path22, _path23, _path24, _path25, _path26, _path27, _g11, _path28, _path29, _path30, _path31, _path32, _path33, _g12, _path34, _path35, _path36, _path37, _path38, _path39, _g13, _path40, _path41, _path42, _g14, _path43, _path44, _path45, _path46, _path47, _g15, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g16, _path58, _g17, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g18, _path71, _g19, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g20, _path84, _g21, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _g22, _path97, _g23, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _g24, _path110, _g25, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g26, _path123, _g27, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _g28, _path136, _g29, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _g30, _path149, _g31, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _g32, _g33, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _g34, _path278;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConsumerGoodsIcon = function SvgConsumerGoodsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.205 92.667"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h84.245v82.842H0z",
    "data-name": "Rectangle 609"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h8.402v10.75H0z",
    "data-name": "Rectangle 545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h4.842v5.542H0z",
    "data-name": "Rectangle 546"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.983v6.802H0z",
    "data-name": "Rectangle 547"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h9.271v8.966H0z",
    "data-name": "Rectangle 548"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.961v6.213H0z",
    "data-name": "Rectangle 550"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.476v6.524H0z",
    "data-name": "Rectangle 551"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.708v6.606H0z",
    "data-name": "Rectangle 552"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M0 0h7.668v6.587H0z",
    "data-name": "Rectangle 554"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.075v5.232H0z",
    "data-name": "Rectangle 555"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h8.217v12.309H0z",
    "data-name": "Rectangle 557"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h6.044v13.756H0z",
    "data-name": "Rectangle 559"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h7.56v13.741H0z",
    "data-name": "Rectangle 561"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h8.352v2.159H0z",
    "data-name": "Rectangle 562"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h12.061v8.883H0z",
    "data-name": "Rectangle 563"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.862v1.566H0z",
    "data-name": "Rectangle 564"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.546v2.278H0z",
    "data-name": "Rectangle 565"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.863v1.566H0z",
    "data-name": "Rectangle 566"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.547v2.278H0z",
    "data-name": "Rectangle 567"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.863v1.564H0z",
    "data-name": "Rectangle 568"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.863v1.565H0z",
    "data-name": "Rectangle 570"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__w"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.864v1.565H0z",
    "data-name": "Rectangle 572"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__x"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.548v2.279H0z",
    "data-name": "Rectangle 577"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__y"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.468v.645H0z",
    "data-name": "Rectangle 595"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__z"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.992v.93H0z",
    "data-name": "Rectangle 597"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consumer_goods_icon_svg__A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.512v6.28H0z",
    "data-name": "Rectangle 606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "consumer_goods_icon_svg__a",
    x1: 0.319,
    x2: 0.876,
    y1: 0.167,
    y2: 0.918,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10042"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeDasharray: 5,
    "data-name": "Path 16565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1.462c27.62 4.174 46.1 20.641 46.1 46.1a46.1 46.1 0 1 1-92.2 0C0 21.102 18.482-3.713 46.1.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M40.067 0h.307l.02.001h.095l.02.001h.057l.018.001h.058l.02.001h.037l.02.001h.038l.02.001h.038l.02.001h.017l.02.001h.038l.02.001h.02l.017.001h.02l.02.001h.018l.02.001h.037l.021.001.02.001h.017l.02.001h.02l.018.001h.02l.02.001h.018l.02.002h.038l.02.001.02.001h.018l.02.001.02.001h.018l.02.001.02.001h.017l.02.001.02.001h.018l.02.002h.02l.019.001h.02l.018.002h.02l.02.001.019.001h.018l.02.002h.02l.018.001.02.001.019.001.02.001h.02l.018.002.04.002h.018l.02.001.02.001.018.001.02.001.02.001.018.001.02.001.02.001.039.002.02.001.017.001.04.002.019.001.02.002h.02l.018.002h.02l.02.002.018.001.02.001.02.001.019.002h.02l.02.002.018.001.02.001.02.002h.019l.02.002.038.002.02.002.02.001.018.001.02.002.04.002.02.001.018.002.02.001.02.001.038.003.02.002h.019l.02.002.02.002q.02 0 .038.003l.02.001.039.003.02.001.038.003.02.002.039.003.02.001.038.003.02.002.098.008.118.01q.825.069 1.66.174l-.125.993a39 39 0 0 0-4.862-.31zm9.918 1.141.546.111.019.004.02.004.005.001.013.003.007.001.013.003.018.004.02.004.014.003.005.001.02.004.016.004h.002l.017.004h.003l.018.004.018.004h.002q.531.112 1.058.23l.018.004h.002l.017.004h.001l.018.004h.002l.017.005h.002l.017.004h.002l.018.004.018.005h.003l.016.004h.003l.015.004.006.001.014.003.019.005h.004l.015.004.005.001.014.003.005.002q.008 0 .014.003h.005l.014.004.056.013.019.004.019.005.057.013q.009.001.018.004l.014.003.005.001.014.004h.005l.014.004.005.001.015.003.004.001.016.004h.003l.016.005h.003l.016.004h.003l.018.005q1.23.286 2.431.608l-.259.966a77 77 0 0 0-4.806-1.12zm9.65 2.597q1.238.428 2.438.896h.001l.017.007h.001l.017.007.002.001.016.007h.002l.016.007h.002l.016.007h.002l.016.007h.002l.144.057h.001l.017.007.002.001.015.006.004.002.014.005.004.002.014.005.004.002.014.006.004.001.013.005.006.003.012.005.005.001.013.006.005.002.012.005.006.002.011.004.007.003.013.005.004.002.016.006h.002l.016.007.002.001.018.007.017.007.006.003.012.004.006.003.011.004.008.003.027.011.008.004.01.003.008.004.018.007.008.003.01.004.008.003.009.004.008.003.01.004.007.003.01.004.008.003.01.004.008.004.009.003.008.004q.005.001.01.004.002 0 .004.002l.013.005h.001l.066.027h.001l.015.006.003.001.013.006.004.002.014.005.003.001.014.006.003.001.015.006.002.001.014.006.003.001.014.006.003.001.015.006.002.001.015.006.002.001.015.007h.001q.608.249 1.203.51l-.4.916a63 63 0 0 0-4.585-1.785zm9.151 4.002q.633.344 1.253.702l.013.007.003.002.012.007q.002 0 .005.003l.01.006.005.002.011.007q.002 0 .005.003l.01.006.006.003.041.024.01.005.007.004.007.005.009.005.007.004.01.005.007.005.008.005.007.004.011.006.005.003.014.008.002.001.033.02.004.002.012.007q.002 0 .005.003l.012.007.004.002.012.008.004.002.014.008.002.001.016.01.068.04.016.01h.001a52 52 0 0 1 2.596 1.635l-.558.83a52 52 0 0 0-4.196-2.538zm8.275 5.586a44.086 44.086 0 0 1 3.109 2.856l.001.001.013.013.054.055.002.002.012.012.001.001.012.013h.001l.043.044.01.01.003.004.01.01.003.003.012.012.027.028.003.003.01.01.004.004.009.009.004.004.009.01.003.003.012.012.001.001.013.014.002.002.01.01.005.005.008.008.005.006.007.007.006.006.007.007.006.006.01.011.005.005.009.009.005.006.013.013.007.007.006.006.006.007.007.006.006.007.006.006.011.012.007.007.006.006.007.007.005.006.013.013.007.007.004.005.008.008.001.001.02.02.002.003.009.009.003.003.009.01.003.003.009.01.002.002.007.007-.723.69a44 44 0 0 0-3.568-3.336zm6.88 7.226.052.07q.486.65.944 1.32l.054.08.001.001.009.012v.001l.036.053.008.012.003.003.007.011.002.003.008.011.026.039q0 0 .002.003l.007.01.002.004.007.01.003.004.007.01.002.004.015.022.001.002.007.01.003.005.016.024.004.006.006.008.005.007.009.013.005.009.005.007.005.007.005.008.005.008.005.007.005.008.005.007.012.017.007.012.004.006.007.01.003.005.007.01.004.006.006.01.004.005.011.017.009.013.002.004.008.011.003.005.007.01q0 .003.003.005l.008.013.002.002.02.031.003.004.007.012.003.004.008.011.003.005.009.013v.002q.011.015.021.032l.001.001.01.014.001.003.01.014v.001l.032.049.01.016q.635.974 1.212 1.985l-.868.496c-.801-1.402-1.701-2.773-2.675-4.074zm4.947 8.66q.366.88.694 1.78v.001l.005.016.029.078.005.013v.004l.005.012.002.005.004.012.002.004.013.037q0 .004.003.008l.003.008.003.009.003.009.003.008.003.009.003.008.003.009.004.012.002.004.006.017.002.005.004.013.002.005.005.013.001.005.005.013.001.004.006.015v.003l.013.035v.002l.007.016v.002l.006.016v.003q.005.007.006.016v.001q.429 1.225.786 2.491l-.963.27a41 41 0 0 0-1.599-4.605zm2.711 9.602q.13.804.232 1.621l.002.02.022.173.002.018v.002l.002.018v.001l.003.018v.001l.015.135.003.019v.001l.002.018v.001l.002.018v.002l.018.153v.001l.002.018v.002l.002.017v.002l.002.017v.002l.002.019.011.097.002.019v.002l.002.017v.002l.002.017v.003l.002.017v.001l.002.018v.001l.013.116v.001q0 .01.002.019 0 .01.002.019v.001q0 .009.002.019 0 .01.002.02l.015.155v.001l.002.018v.001l.002.02q.1 1.033.159 2.088l-.999.055a47 47 0 0 0-.519-4.864zm-.446 9.921 1 .048a46 46 0 0 1-.27 3.255l-.002.018-.002.017v.003l-.002.015v.003l-.002.015v.004l-.003.015v.003l-.002.015v.004l-.002.014v.004l-.002.015v.002l-.01.07v.012l-.002.007v.01l-.002.01-.001.009-.001.009-.001.009-.002.01v.009l-.002.01v.008l-.002.01-.001.009-.002.01v.008l-.002.012v.006l-.003.014v.005l-.002.015v.004l-.003.018-.012.096-.005.038v.002l-.003.018q0 .01-.003.02-.073.558-.16 1.112l-.988-.155c.251-1.6.417-3.238.494-4.865m-1.512 9.647.965.26q-.395 1.459-.88 2.875l-.006.017-.006.016v.001l-.046.133-.006.018-.006.015v.002l-.005.015v.001l-.041.115v.001l-.006.015v.003l-.005.013-.002.004-.004.013-.002.004-.005.014v.002l-.035.099-.005.014-.001.003-.005.013-.002.004-.004.014-.002.003-.004.014-.002.003-.005.014v.002l-.035.097v.001l-.006.015v.002l-.006.015-.001.002-.005.015-.001.002-.005.015-.001.002-.005.015-.036.098-.001.002-.005.014-.001.003-.006.017-.006.014v.002l-.006.015q-.173.474-.357.94l-.93-.365a45 45 0 0 0 1.533-4.641m-3.564 9.088.886.464q-.212.404-.431.803v.001l-.008.014-.001.002-.008.014-.008.015-.001.001-.04.074-.002.002-.007.013-.002.004-.006.011-.002.004-.007.012-.002.004-.007.012-.002.003-.03.056-.002.003-.007.011-.002.005-.006.01-.003.006-.018.032-.006.01-.003.006-.006.01q0 .003-.003.005l-.02.036-.003.006-.005.01q-.003.002-.004.006l-.005.009-.004.008-.005.008-.004.007-.005.01-.004.006-.005.01-.005.007-.004.008-.005.009-.004.007-.009.015-.004.008-.005.009-.004.006-.006.01-.003.007-.006.01-.004.006-.005.01-.004.007-.005.009-.004.007-.006.01-.003.006-.008.012-.001.004-.01.016-.001.002-.008.015-.002.003-.007.013-.003.005-.007.011-.003.005-.006.011-.003.006-.007.011-.002.005-.008.013q0 0-.002.003l-.028.05-.001.001-.008.015-.003.004-.01.017-.006.011-.003.005-.007.012-.002.004-.008.013-.03.053-.002.002-.008.014-.012.02-.007.013-.002.004-.008.013q0 .001-.002.003l-.008.014-.001.002-.039.067-.001.002-.008.014-.002.003-.008.013-.002.004-.008.013-.01.017-.001.002-.039.067-.001.001-.009.015-.001.003-.008.013-.002.003-.008.014-.002.002-.008.015-.001.002-.04.066v.002l-.01.014v.003q-.005.007-.009.013l-.01.017-.002.003-.008.014-.001.003-.04.066-.01.016v.001l-.01.015v.003l-.01.014v.002l-.01.015v.001l-.05.083-.001.001-.009.015-.002.002-.008.014-.001.003-.01.015-.05.083-.001.002-.009.014-.001.003-.01.014v.002l-.01.015v.001l-.05.082-.002.002-.008.014-.002.003-.009.014-.001.002-.009.015v.001l-.052.083-.01.016v.002l-.01.014v.002l-.01.015v.001l-.052.083-.01.015-.001.003-.01.014v.001l-.01.016-.052.083-.01.016-.001.002-.009.014-.001.002-.01.014v.002l-.01.016-.052.082-.001.001-.01.015v.002l-.01.015v.001l-.01.016-.053.082-.01.016-.011.017q-.284.445-.577.88l-.83-.557a45 45 0 0 0 2.501-4.2m-5.442 8.108.765.643q-.705.839-1.447 1.64-.04.044-.08.087l-.012.014h-.001l-.012.013-.002.002-.012.013v.001l-.014.014-.026.028-.013.014-.002.003-.01.01-.004.004-.01.01-.003.004-.01.01-.004.005-.008.009-.013.014-.004.004-.012.012-.002.003-.011.012-.005.004-.008.01-.005.004-.008.009q-.003.002-.005.006l-.007.007-.006.006-.007.007-.007.007-.005.006-.007.007-.005.006-.03.031-.002.002-.008.01q-.003 0-.004.004l-.009.008-.004.004-.008.01q-.003 0-.004.004l-.009.009-.003.003-.01.01-.001.002-.058.06v.001l-.012.012-.001.001-.011.012q-.712.746-1.457 1.458l-.691-.722a46 46 0 0 0 3.344-3.567m-7.053 6.753.61.793a46 46 0 0 1-4.12 2.829l-.52-.854a45 45 0 0 0 4.03-2.768m-8.337 5.083.425.906q-.45.21-.902.411l-.002.001-.015.007-.004.001-.014.007-.003.001-.014.006-.004.002-.013.006-.004.002-.013.005-.005.002-.015.007h-.002l-.017.008-.004.002-.013.006-.007.003-.01.004-.008.004-.01.004-.007.003-.009.004-.008.004-.009.003-.009.004-.006.003-.011.005-.005.002-.012.005-.002.001-.046.02-.014.006-.003.002-.013.005-.004.002-.013.006-.003.001-.013.006-.003.001-.014.006h-.002l-.015.007a46 46 0 0 1-2.55 1.012l-.015.006-.016.006h-.001l-.115.042h-.001l-.015.005-.002.001-.015.005-.002.001-.017.006-.015.005-.002.001-.015.006-.064.022-.003.001-.013.005-.004.002-.012.004-.017.006-.024.008-.01.004-.009.003-.009.003-.008.003-.017.006-.019.006-.017.006-.008.003-.01.004-.026.009-.008.003-.01.003-.008.003-.01.003-.007.003-.01.004-.008.002-.012.004-.005.002-.036.013H61.2l-.014.006-.006.002-.012.004-.005.002-.013.004-.005.002-.013.005-.005.001-.014.005-.004.001-.016.006h-.002l-.055.02-.324-.947a45 45 0 0 0 4.532-1.833m-9.237 3.161.22.976q-.323.071-.644.14h-.003l-.016.003-.018.004-.019.004h-.005l-.02.005-.01.002-.008.002-.01.002-.008.002-.019.003-.018.004-.019.004-.018.004-.036.007-.018.004-.054.01-.018.004-.034.007-.015.003h-.002l-.14.028q-1.862.368-3.777.584l-.112-.994a45 45 0 0 0 4.821-.808m-14.589.851c1.612.166 3.257.247 4.886.24l.004 1h-.535l-.019-.001h-.094l-.019-.001h-.075l-.018-.001h-.037l-.038-.001h-.057l-.018-.001h-.057l-.018-.001h-.037l-.02-.001h-.037l-.018-.001h-.02l-.018-.001h-.037l-.02-.001h-.036l-.019-.001-.038-.001h-.018l-.019-.001h-.037l-.019-.001-.126-.004h-.033l-.021-.001h-.02l-.017-.001h-.017l-.02-.001-.018-.001h-.019l-.017-.001h-.02l-.02-.001h-.018l-.018-.002h-.037l-.019-.001-.018-.001h-.019l-.018-.001-.019-.001h-.019l-.019-.001-.018-.001h-.018l-.019-.001-.019-.001h-.019l-.018-.002h-.019l-.019-.001h-.018l-.018-.002h-.019l-.019-.001h-.018l-.019-.002h-.018l-.02-.001-.018-.001h-.018l-.019-.002h-.019l-.018-.001-.019-.001-.018-.001h-.019l-.018-.002h-.019l-.018-.002h-.002a46 46 0 0 1-2.56-.192zm-9.545-2.05c1.54.512 3.128.945 4.716 1.286l-.21.977-.017-.004h-.003l-.017-.004h-.002l-.076-.017h-.001l-.017-.004h-.004l-.014-.004q-.01 0-.019-.004l-.018-.004-.018-.004-.018-.004-.019-.004q-.01 0-.017-.004-.01 0-.017-.003l-.059-.013-.018-.004-.018-.004-.006-.002-.018-.004q-.008 0-.018-.004l-.016-.003-.016-.004-.103-.023h-.001l-.017-.004-.017-.004h-.001a46 46 0 0 1-4.236-1.185zm-8.875-4.068c1.396.834 2.851 1.6 4.327 2.276l-.417.91-.098-.046a46 46 0 0 1-3.43-1.76l-.012-.007-.004-.002-.011-.007q-.002 0-.005-.003l-.01-.005-.006-.004-.01-.005-.006-.004-.01-.005-.006-.004-.01-.006-.007-.004-.008-.004-.013-.008-.008-.004-.011-.007-.005-.002-.011-.007-.006-.003-.011-.006-.005-.003-.011-.007-.005-.002-.013-.008-.003-.002-.014-.008h-.002l-.1-.059q-.287-.165-.572-.336zm-7.792-5.885a46 46 0 0 0 3.737 3.153l-.603.798q-.39-.294-.772-.596l-.003-.003-.012-.009-.004-.003-.01-.009-.005-.003-.01-.008-.005-.004-.01-.008q-.002-.002-.005-.003l-.01-.01-.004-.002-.015-.012-.004-.003-.01-.008-.007-.005-.008-.006-.007-.006-.007-.006-.007-.006-.007-.005-.008-.006-.006-.005-.008-.007-.006-.004-.01-.008-.002-.002-.05-.04-.002-.001-.011-.01-.003-.002-.014-.01-.012-.01-.001-.001-.08-.064-.013-.011-.014-.011a46 46 0 0 1-1.947-1.662l-.012-.01v-.001l-.013-.011-.063-.057-.002-.002-.01-.01-.004-.002-.01-.01-.003-.002-.01-.01-.003-.002-.01-.01h-.002l-.06-.056-.003-.003-.01-.009-.004-.003-.01-.009-.003-.004-.01-.008-.003-.003-.01-.01-.002-.001-.047-.043-.003-.003-.009-.008-.005-.005-.008-.007-.006-.006-.007-.006-.006-.006-.008-.007-.005-.005-.008-.007-.006-.005-.008-.008-.005-.004-.015-.015-.013-.011-.006-.006-.007-.007-.007-.006-.007-.006-.006-.006-.007-.007-.007-.006-.007-.006-.007-.007-.006-.006-.01-.008-.004-.004-.013-.013-.003-.003-.01-.01-.005-.003-.01-.01-.004-.004-.01-.008-.004-.004-.014-.013-.01-.009-.003-.004-.01-.009-.004-.004-.027-.025-.002-.002-.012-.011-.003-.003-.01-.01-.005-.004-.01-.009-.004-.004-.009-.009-.004-.004-.01-.009-.004-.003-.011-.01-.002-.003zm-6.352-7.418a46 46 0 0 0 2.976 3.88l-.76.651-.012-.014-.002-.002-.01-.012-.003-.004-.009-.01-.004-.005-.008-.01-.004-.004-.008-.01-.004-.004-.009-.01-.015-.018-.006-.007-.006-.007-.007-.008-.004-.006-.008-.008-.004-.006-.008-.009-.004-.004-.007-.01q-.003 0-.004-.004l-.009-.01-.002-.002-.065-.078-.011-.013a46 46 0 0 1-1.133-1.397v-.001l-.01-.013-.01-.013-.002-.002-.01-.012v-.002l-.01-.012-.002-.002-.041-.054-.008-.01-.004-.004-.007-.01-.004-.005-.007-.01-.004-.005-.007-.008-.005-.007-.006-.008-.005-.007-.006-.007-.008-.01-.007-.01-.007-.009-.005-.006-.006-.008-.005-.007-.007-.008-.005-.007-.006-.008-.005-.006-.007-.01-.004-.005-.008-.01-.003-.004-.01-.014-.002-.001-.023-.03-.001-.003-.01-.013-.002-.002-.01-.013-.002-.003-.01-.012q0-.001-.002-.003l-.01-.014A46 46 0 0 1 8.03 72.57zm-4.609-8.607a45 45 0 0 0 2.07 4.43l-.881.471a46 46 0 0 1-.52-1.002h-.001l-.008-.016-.001-.002-.008-.015v-.002l-.009-.017-.035-.07-.008-.016-.002-.004-.007-.013-.002-.004-.006-.012-.002-.005-.007-.013-.002-.004-.006-.013-.002-.004-.008-.015v-.002l-.017-.034-.003-.004-.006-.012-.002-.006-.006-.011-.003-.006-.005-.01-.004-.007-.004-.01-.004-.007-.005-.01-.003-.007-.005-.01-.003-.007-.005-.01-.004-.007-.008-.015q-.001-.004-.004-.01l-.004-.007-.004-.008-.004-.009-.004-.008-.004-.008-.004-.009-.004-.008-.004-.008-.004-.008-.004-.009-.004-.008-.005-.009-.003-.006-.005-.01-.022-.045-.001-.003-.006-.012-.002-.005-.006-.012-.002-.004-.006-.011-.002-.006-.006-.011-.002-.004-.006-.013-.001-.002-.037-.076v-.001l-.006-.013-.002-.004-.007-.013-.001-.003-.006-.013-.002-.003-.006-.014-.001-.001a46 46 0 0 1-1.204-2.731zM1.61 54c.266 1.604.623 3.21 1.061 4.772l-.963.27a46 46 0 0 1-1.085-4.878zM.053 44.197l1 .045A52 52 0 0 0 1 46.564c0 .857.024 1.723.072 2.575l-.998.056-.016-.295v-.019l-.002-.018v-.001l-.004-.085v-.018l-.001-.01v-.01l-.001-.01v-.008l-.001-.012v-.02l-.001-.007v-.014l-.001-.006-.004-.08v-.022l-.001-.018v-.003l-.001-.018v-.001L.04 48.5q-.026-.615-.035-1.234v-.083l-.002-.082v-.084L.001 47v-.111L0 46.876v-.233L0 46.631v-.381l.001-.004v-.126q.009-.963.052-1.923m1.375-9.89.974.228a53 53 0 0 0-.901 4.822l-.99-.138q.078-.562.168-1.122 0-.01.003-.02l.003-.018v-.001l.012-.075.001-.006.002-.013.001-.006.003-.018.002-.014.001-.005.002-.013.001-.006.003-.016v-.002l.003-.018.001-.004.002-.014.001-.007.002-.011.002-.008.001-.01.002-.008.001-.01.002-.009.001-.01.002-.008.001-.008.004-.023v-.004l.003-.012v-.006l.003-.012v-.006l.003-.012v-.005l.003-.013.003-.018v-.003l.014-.083.003-.015v-.002l.003-.015v-.002a54 54 0 0 1 .656-3.222m3.194-9.461.913.409a51 51 0 0 0-1.787 4.564l-.947-.32.022-.067.001-.003.005-.012.001-.005.004-.011.002-.006.004-.011.002-.007.004-.01.002-.007.003-.01.006-.017.002-.006.004-.01.003-.009.003-.01.003-.007.006-.018.003-.01.002-.007.004-.01q0-.004.003-.008l.005-.017.006-.016.003-.008.003-.01.003-.007q0-.006.003-.01l.003-.008q0-.005.004-.011l.002-.006.004-.012q0-.003.002-.005l.012-.036v-.001l.006-.017.008-.022.004-.013.007-.019.001-.003.02-.055.005-.017.001-.003.006-.016v-.002l.006-.016v-.002a52 52 0 0 1 1.618-4.06m4.985-8.65.81.588a46 46 0 0 0-2.659 4.107l-.866-.499q.045-.08.093-.16.024-.044.05-.086v-.002l.008-.013.034-.057.007-.013.002-.003.007-.012.001-.003.007-.012.002-.003.03-.052.003-.004.006-.01.003-.005.006-.01.003-.005.006-.01.024-.04.002-.005.006-.01.004-.006.009-.015.006-.01.002-.005.007-.01.001-.003.013-.021.003-.006.006-.009.003-.006.005-.009.005-.007.005-.008.004-.007.005-.008.009-.016.009-.015.004-.007.005-.008.004-.007.006-.01.004-.006.005-.01.004-.006.006-.01.025-.042.006-.01.004-.006.006-.01.01-.016.003-.006.007-.012.002-.003.01-.016.003-.004.006-.012.004-.006.006-.01.004-.006.005-.01.004-.005.007-.01.002-.006.01-.015.002-.004.007-.012.003-.005.007-.01.003-.006.02-.032.008-.014.001-.001.01-.016.002-.004.007-.012.003-.005.007-.01.003-.006.01-.016.007-.012.002-.004.02-.031.002-.004.007-.012.003-.004.007-.012.003-.005.008-.012.001-.003.02-.033h.001l.009-.015.002-.004.008-.012.002-.004.008-.012.002-.004.009-.014v-.002l.02-.032.002-.003.008-.012.003-.005.007-.011.003-.005.008-.012.022-.036v-.001l.01-.014.001-.004.008-.012.003-.004.007-.012.003-.004.008-.013.001-.003.02-.032.002-.003.008-.013.003-.003.007-.012.003-.004.008-.014.001-.002.02-.032.002-.002.008-.014.003-.004.007-.012.003-.003.008-.013q0-.002.002-.003l.03-.048.001-.002.009-.014.01-.016.002-.003.008-.013.002-.003.02-.032.001-.001.01-.015.001-.003.008-.012.003-.004.008-.013q0-.002.002-.003l.009-.015.011-.017.01-.015.002-.004.008-.012.002-.004.008-.012.003-.004.008-.013.001-.002.02-.032.002-.003.009-.012.002-.005.02-.031.01-.014v-.002l.01-.015.002-.003.009-.013.002-.004.007-.011.004-.005.007-.011.003-.005.007-.012.003-.003.02-.031.003-.005.007-.01.003-.006.007-.01.003-.006.007-.01.003-.005.008-.012.002-.003.01-.016.002-.003.012-.017.006-.01.004-.006.006-.009.004-.007.006-.009.004-.006.008-.012.005-.007.017-.026.004-.007.005-.008.005-.007.005-.008.005-.008.006-.009.004-.005.014-.022.005-.008.005-.007.005-.008.005-.007.005-.008.005-.008.005-.007.005-.008.008-.013.005-.006.006-.01.005-.007.005-.008.005-.007.005-.008.005-.008.005-.007.005-.008.005-.008.009-.013.005-.008.006-.008.004-.006.006-.01.004-.005.006-.01.004-.005.006-.01.038-.056.007-.01.01-.015.002-.004.033-.05.003-.003.007-.011.002-.003.008-.012.001-.002.008-.012.037-.055.009-.013.001-.002.009-.012.046-.069q.423-.625.865-1.233m6.746-7.35.65.76a40 40 0 0 0-3.501 3.392l-.738-.675a41 41 0 0 1 2.995-2.958l.002-.002.01-.01.002-.001.01-.01h.002l.032-.03q.003 0 .004-.003l.009-.007.005-.005.008-.007.005-.005.007-.006.007-.006.012-.01.007-.007.006-.005.008-.007.005-.005.01-.008.004-.004.01-.01.003-.001.029-.026.014-.012.001-.001.014-.012q.183-.162.368-.32m8.355-5.441.427.904a36 36 0 0 0-4.24 2.374l-.547-.837.004-.003.007-.004.008-.005.007-.005.014-.01q.004 0 .007-.004l.008-.005.008-.005.007-.005.008-.004.007-.005.008-.005.007-.005.012-.008.009-.005.008-.006.008-.005.007-.004.008-.006.007-.004.008-.005.007-.005.03-.02.006-.003.008-.005.007-.005.008-.005.007-.004.008-.006.006-.003.02-.013.003-.002.01-.006.004-.003.01-.006.005-.004.01-.006.02-.013.017-.01.005-.004.01-.006.005-.003.01-.006.005-.004.01-.006.004-.003.033-.02.005-.004.01-.006.015-.01.004-.002.01-.007.003-.001.037-.023q0-.002.003-.002l.01-.007q.003 0 .004-.003l.01-.006q.002 0 .005-.003l.052-.033.012-.007.003-.002.011-.007.002-.001.052-.033h.002l.012-.008.002-.001.067-.042a36 36 0 0 1 3.594-1.954M34.229.459l.158.987c-1.6.257-3.19.628-4.727 1.104l-.296-.956A35 35 0 0 1 34.23.46M40.067 0v1q-.42 0-.84.01l-.022-1 .313-.005h.016l.036-.001h.053l.015-.001h.085L39.737 0h.131L39.885 0h.182",
    className: "consumer_goods_icon_svg__stokre-color"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#consumer_goods_icon_svg__a)",
    d: "M40.669 6.243c24.809 0 54.879 18.735 53.887 50.608s-44.082 35.618-58.815 32.16S12.1 68.886 12.1 44.077 15.86 6.243 40.669 6.243",
    "data-name": "Path 16564",
    transform: "translate(-4.965 -1.745)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9235",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__b)",
    "data-name": "Group 9234",
    transform: "translate(4.041 7.277)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9233"
  }, /*#__PURE__*/React.createElement("g", {
    className: "consumer_goods_icon_svg__cons",
    clipPath: "url(#consumer_goods_icon_svg__b)",
    "data-name": "Group 9232",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#492c0d",
    d: "M66.781 15.28h8.747l.534-.434h-8.313Z",
    "data-name": "Path 14188"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d0a00",
    d: "M70.355 15.225a.234.234 0 1 1-.234-.234.234.234 0 0 1 .234.234",
    "data-name": "Path 14189"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d0a00",
    d: "M73.205 15.225a.233.233 0 1 1-.233-.234.233.233 0 0 1 .233.234",
    "data-name": "Path 14190"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d0a00",
    d: "m73.036 15.236-.131-.024a1.6 1.6 0 0 0-.249-1.382 1.55 1.55 0 0 0-1.108-.448 1.35 1.35 0 0 0-1.058.452 1.95 1.95 0 0 0-.3 1.379l-.131.022a2.05 2.05 0 0 1 .331-1.486 1.48 1.48 0 0 1 1.156-.5 1.66 1.66 0 0 1 1.213.493 1.73 1.73 0 0 1 .279 1.494",
    "data-name": "Path 14191"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M75.096 26.031h-8.313v-10.75h8.747Z",
    "data-name": "Path 14192"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9132",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9131"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__c)",
    "data-name": "Group 9130",
    transform: "translate(66.781 15.281)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "M2.225 4.283A12 12 0 0 1 .948.111C.948.074.94.037.937 0h-.938v10.75h8.316l.089-2.19c-2.6.262-5.08-2.132-6.177-4.277",
    "data-name": "Path 14193"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#915513",
    d: "m75.094 26.031 1.5-1-.534-10.183-.534.434Z",
    "data-name": "Path 14194"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#301f0f",
    d: "M69.964 15.898a.234.234 0 1 1-.234-.234.234.234 0 0 1 .234.234",
    "data-name": "Path 14195"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#301f0f",
    d: "M72.814 15.898a.233.233 0 1 1-.233-.234.233.233 0 0 1 .233.234",
    "data-name": "Path 14196"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#301f0f",
    d: "m72.646 15.91-.132-.024a1.61 1.61 0 0 0-.248-1.382 1.55 1.55 0 0 0-1.109-.448 1.35 1.35 0 0 0-1.058.452 1.96 1.96 0 0 0-.3 1.379l-.132.022a2.06 2.06 0 0 1 .332-1.485 1.48 1.48 0 0 1 1.157-.5 1.66 1.66 0 0 1 1.213.493 1.73 1.73 0 0 1 .28 1.494",
    "data-name": "Path 14197"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9135",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9134"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__d)",
    "data-name": "Group 9133",
    transform: "translate(69.885 16.416)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.003 0a5.36 5.36 0 0 0 4.484 5.542L4.843 0Z",
    "data-name": "Path 14198"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M13.016 13.227c.692-.027 1.384-.04 2.076-.059s1.384-.024 2.076-.037l-.06.021.108-.1c.037-.032.065-.07.1-.1a.6.6 0 0 0 .128-.223.2.2 0 0 0 0-.1.2.2 0 0 0-.047-.087.4.4 0 0 0-.092-.074.6.6 0 0 0-.113-.051h.008l-.534-.132a6 6 0 0 1-.529-.148l-.524-.164-.516-.189c-.173-.06-.341-.133-.51-.2s-.338-.14-.5-.217-.333-.151-.5-.234-.327-.164-.491-.254l.129.005c-.323.159-.66.333-1 .488-.172.074-.34.156-.514.224l-.26.1c-.087.033-.173.072-.262.1l-.529.184c-.178.057-.357.107-.536.161s-.359.1-.541.145l-.543.131h.008a.5.5 0 0 0-.112.051.4.4 0 0 0-.092.074.2.2 0 0 0-.047.087.2.2 0 0 0 0 .1.6.6 0 0 0 .129.223 1 1 0 0 0 .1.1l.108.1-.061-.021c.692.013 1.383.018 2.075.037s1.383.032 2.075.059c-.692.027-1.383.04-2.075.059s-1.383.024-2.075.037h-.029l-.026-.022-.122-.1a2 2 0 0 1-.115-.116 1 1 0 0 1-.1-.134.7.7 0 0 1-.076-.167.4.4 0 0 1-.01-.2.4.4 0 0 1 .089-.184.6.6 0 0 1 .142-.123.8.8 0 0 1 .164-.08h.008c.354-.1.716-.17 1.065-.286.175-.055.352-.106.526-.164l.518-.186c.087-.029.17-.068.256-.1l.254-.1c.17-.069.335-.15.5-.225.334-.157.652-.329.993-.5l.064-.031.065.037q.231.13.475.251a18 18 0 0 0 .98.454c.166.069.331.144.5.2l.506.191.514.167q.256.087.519.151l.522.14h.009a.7.7 0 0 1 .164.08.6.6 0 0 1 .142.123.4.4 0 0 1 .089.184.4.4 0 0 1-.01.2.7.7 0 0 1-.076.167 1 1 0 0 1-.1.134c-.039.038-.074.082-.116.116l-.122.1-.025.022h-.035c-.692-.013-1.384-.017-2.076-.037s-1.384-.032-2.076-.059",
    "data-name": "Path 14199"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M13.167 10.753a.5.5 0 0 0-.048.093l-.041.1a5 5 0 0 0-.076.191 2.3 2.3 0 0 0-.112.374 1 1 0 0 0-.011.088.4.4 0 0 0 0 .081.2.2 0 0 0 .012.069.1.1 0 0 0 .026.052c.005.018.026.026.039.04s.038.021.059.032a.2.2 0 0 0 .076.022l.085.019h-.016a.4.4 0 0 0 .081-.011 1 1 0 0 0 .081-.024.3.3 0 0 0 .065-.037.3.3 0 0 0 .046-.054.36.36 0 0 0 .024-.176 2 2 0 0 0-.045-.213.8.8 0 0 1 .142.183.6.6 0 0 1 .042.118.4.4 0 0 1 0 .137.35.35 0 0 1-.06.137.5.5 0 0 1-.105.1.5.5 0 0 1-.121.062.6.6 0 0 1-.132.034h-.016l-.121-.01a.4.4 0 0 1-.124-.031.4.4 0 0 1-.124-.062.35.35 0 0 1-.106-.105.4.4 0 0 1-.061-.135.4.4 0 0 1-.018-.136.4.4 0 0 1 .011-.126 1 1 0 0 1 .03-.115 1 1 0 0 1 .09-.208 1.5 1.5 0 0 1 .12-.184 1.4 1.4 0 0 1 .141-.165.7.7 0 0 1 .17-.135",
    "data-name": "Path 14200"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#282f36",
    d: "M13.075 10.753a.8.8 0 0 0 .079-.14l.068-.145q.066-.148.125-.292a3.6 3.6 0 0 0 .184-.58.63.63 0 0 0-.039-.473.3.3 0 0 0-.068-.069.4.4 0 0 0-.1-.053.7.7 0 0 0-.124-.035c-.042-.013-.091-.015-.137-.024h.022c-.014 0-.041 0-.063.005s-.046.007-.068.013a1 1 0 0 0-.128.041.5.5 0 0 0-.1.064l-.04.043-.032.05a.4.4 0 0 0-.03.129.7.7 0 0 0 0 .152c.013.051.018.107.032.161s.03.109.047.165c-.037-.043-.078-.086-.114-.132a2 2 0 0 1-.094-.153 1 1 0 0 1-.06-.18.6.6 0 0 1 0-.206l.033-.106q.026-.048.057-.1a.7.7 0 0 1 .158-.146.8.8 0 0 1 .182-.092q.046-.017.1-.029a1 1 0 0 1 .1-.02h.022a2 2 0 0 1 .182.013 1 1 0 0 1 .187.046.8.8 0 0 1 .186.094.6.6 0 0 1 .159.157.73.73 0 0 1 .118.4 1.2 1.2 0 0 1-.062.364 2.1 2.1 0 0 1-.313.6 2.4 2.4 0 0 1-.211.257 2 2 0 0 1-.119.116.6.6 0 0 1-.136.1",
    "data-name": "Path 14201"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m15.955 11.629-.611-.225a2.66 2.66 0 0 1-2.157 2 2.66 2.66 0 0 1-2.157-2l-.612.225a2.67 2.67 0 0 1-.611 2.9 12.5 12.5 0 0 1 1.031 3.734h4.7a12.5 12.5 0 0 1 1.03-3.734 2.68 2.68 0 0 1-.611-2.9",
    "data-name": "Path 14202"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9138",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9137"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__e)",
    "data-name": "Group 9136",
    transform: "translate(9.806 11.459)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "M5.811 5.346a3.8 3.8 0 0 1-2.927-.7 4.93 4.93 0 0 1-1.611-2.765 6.4 6.4 0 0 1-.2-1.735V.004L.609.175a2.67 2.67 0 0 1-.611 2.9 12.5 12.5 0 0 1 1.03 3.734h4.7a9 9 0 0 1 .253-1.5 2 2 0 0 1-.172.041",
    "data-name": "Path 14203"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M17.758 26.037s-2.061-5.629-2.222-7.779h-4.7s.064 1.74-2.35 7.779c0 0 4.625 2.671 9.271 0",
    "data-name": "Path 14204"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9141",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9140"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__f)",
    "data-name": "Group 9139",
    transform: "translate(8.487 18.261)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "M8.705 6.165a2 2 0 0 1-.136.251 3.14 3.14 0 0 1-1.524 1.186 3.91 3.91 0 0 1-4.073-.43A3.4 3.4 0 0 1 1.895 5.23a5.6 5.6 0 0 1 .267-2.4A12.6 12.6 0 0 1 3.095.452c.071-.139.148-.295.237-.45H2.35S2.414 1.742 0 7.781c0 0 4.624 2.671 9.271 0 0 0-.241-.66-.565-1.613",
    "data-name": "Path 14205"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#22282e",
    d: "M10.611 17.842h5.151v.805h-5.151z",
    "data-name": "Rectangle 549"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9144",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9143"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__g)",
    "data-name": "Group 9142",
    transform: "translate(11.034 18.969)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.961 0 0 5.483a1.38 1.38 0 0 0 .881.729Z",
    "data-name": "Path 14206"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9147",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9146"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__h)",
    "data-name": "Group 9145",
    transform: "translate(15.06 18.969)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m0 0 1.475 5.859a1.45 1.45 0 0 1-.862.666Z",
    "data-name": "Path 14207"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9150",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9149"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__i)",
    "data-name": "Group 9148",
    transform: "translate(13.123 18.969)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m.35 0-.354 6.524s.515.183.708 0Z",
    "data-name": "Path 14208"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#005177",
    d: "M1.594 40.503h9.9a1.6 1.6 0 0 1 1.6 1.6v5.47a1.594 1.594 0 0 1-1.594 1.589H1.594A1.594 1.594 0 0 1 0 47.568v-5.471a1.594 1.594 0 0 1 1.594-1.594",
    "data-name": "Rectangle 553"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M1.98 40.845a8.4 8.4 0 0 0 .5 1.568 10 10 0 0 0 .655 1.286 6.7 6.7 0 0 0 1.06 1.3 7.4 7.4 0 0 0 3.567 1.954 6.9 6.9 0 0 0 3.382-.169 10 10 0 0 0 1.945-.8v-5.12a.363.363 0 0 0-.363-.363H1.919q.025.172.061.342",
    "data-name": "Path 14209"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9153",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9152"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__j)",
    "data-name": "Group 9151",
    transform: "translate(5.426 40.503)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M7.305 0h-7.3a5.3 5.3 0 0 1 2.317 1.607 5.05 5.05 0 0 1 .854 1.922 4.5 4.5 0 0 1-.025 2.08 6 6 0 0 1-.31.924 7 7 0 0 0 2.885-.253 10 10 0 0 0 1.945-.8V.361a.363.363 0 0 0-.363-.363",
    "data-name": "Path 14210"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e34",
    d: "M12.368 46.401a8.3 8.3 0 0 1-3.236.756 6.86 6.86 0 0 1-3.56-1.023 7.4 7.4 0 0 1-2.522-2.47 9.1 9.1 0 0 1-1.132-2.834 6 6 0 0 1-.056-.326H.363a.363.363 0 0 0-.363.36v7.934a.363.363 0 0 0 .363.363h12.368a.363.363 0 0 0 .363-.363v-2.75q-.356.19-.726.351",
    "data-name": "Path 14211"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M12.368 46.401a8.3 8.3 0 0 1-3.236.756 6.86 6.86 0 0 1-3.56-1.023 7.4 7.4 0 0 1-2.522-2.47 9.1 9.1 0 0 1-1.132-2.834 6 6 0 0 1-.056-.326H.363a.363.363 0 0 0-.363.36v7.934a.363.363 0 0 0 .363.363h12.368a.363.363 0 0 0 .363-.363v-2.75q-.356.19-.726.351",
    "data-name": "Path 14212"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.272 40.822a9.9 9.9 0 0 0 1.227 3.072 8.04 8.04 0 0 0 2.734 2.678 7.44 7.44 0 0 0 3.858 1.109 9 9 0 0 0 3.508-.82q.25-.109.5-.231v-.58q-.356.19-.726.351a8.3 8.3 0 0 1-3.236.756 6.87 6.87 0 0 1-3.565-1.023 7.4 7.4 0 0 1-2.523-2.47 9.1 9.1 0 0 1-1.132-2.834 6 6 0 0 1-.056-.326h-.645q.024.164.055.319",
    "data-name": "Path 14213"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9156",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9155"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#bababa",
    clipPath: "url(#consumer_goods_icon_svg__k)",
    "data-name": "Group 9154",
    transform: "translate(0 43.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.534a2.88 2.88 0 0 1 .578 1.7A5.24 5.24 0 0 0 0 .004a2.9 2.9 0 0 1 1.538.573A4.98 4.98 0 0 1 4.5 3.534",
    "data-name": "Path 14214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.516v.279c.214 0 .425.019.631.042-.023-.1-.047-.2-.071-.287Q.284 1.523 0 1.517",
    "data-name": "Path 14215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.871 2.202q.102.203.191.419A3.38 3.38 0 0 1 4.74 4.714a.67.67 0 0 1 .335.519 2.88 2.88 0 0 0-.578-1.7A4.5 4.5 0 0 0 2.871 2.2",
    "data-name": "Path 14216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.926 1.876a6.2 6.2 0 0 1 1.739.532q-.1-.207-.213-.4A6.6 6.6 0 0 0 .86 1.582q.036.142.067.291",
    "data-name": "Path 14217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.837v.278q.486 0 .93.028l-.017-.278c-.3-.016-.608-.026-.912-.028",
    "data-name": "Path 14218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.19 3.882.017.278a13.4 13.4 0 0 1 2.028.281q-.016-.149-.039-.3a15 15 0 0 0-2.006-.264",
    "data-name": "Path 14219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74 4.71a3.8 3.8 0 0 0-1.253-.5q.021.15.036.3c.821.219 1.273.491 1.273.72h.279a.67.67 0 0 0-.335-.518",
    "data-name": "Path 14220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.062 2.621a6 6 0 0 0-.191-.419A4.5 4.5 0 0 0 1.538.576 2.9 2.9 0 0 0 0 .003v.024a.8.8 0 0 1 .359.306 3.38 3.38 0 0 1 2.093 1.678q.113.19.213.4A6.2 6.2 0 0 1 3.2 4.146q.022.15.04.3a7 7 0 0 1 .044.791h.279q0-.366-.036-.72-.015-.152-.036-.3a6.6 6.6 0 0 0-.425-1.592",
    "data-name": "Path 14221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.926 1.876c-.021-.1-.043-.2-.067-.291a3.8 3.8 0 0 0-.5-1.252A.8.8 0 0 0 0 .027v.318A2.57 2.57 0 0 1 .56 1.55q.036.137.071.287a13.4 13.4 0 0 1 .281 2.028q.01.137.018.278.027.516.028 1.089h.278a20 20 0 0 0-.045-1.35 15 15 0 0 0-.264-2.006",
    "data-name": "Path 14222"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m39.863 1.288 6.23-1.006 1.987 12.31-6.23 1.005z",
    "data-name": "Rectangle 556"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "m44.576 1.359-2.932.473a.99.99 0 0 1-.819 1.135l1.386 8.6a.984.984 0 0 1 1.147.958l2.953-.476a1 1 0 0 1-.033-.135.99.99 0 0 1 .82-1.135l-1.387-8.6a.99.99 0 0 1-1.135-.82",
    "data-name": "Path 14223"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "M43.535 4.237a2.738 2.738 0 1 1-2.266 3.14 2.74 2.74 0 0 1 2.266-3.14",
    "data-name": "Path 14224"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#707e3d",
    d: "m41.845 7.205-.014-.086a1.8 1.8 0 0 1 .064-.971.7.7 0 0 1 .568-.453.5.5 0 0 1 .394.095.52.52 0 0 1 .215.352.6.6 0 0 1-.07.406.45.45 0 0 1-.343.222.5.5 0 0 1-.367-.065.4.4 0 0 1-.189-.213q-.032-.115-.086-.1c-.054.015-.076.081-.1.222a1.4 1.4 0 0 0 0 .417l.032.161 1.261-.2q.087-.386.169-.771a1.6 1.6 0 0 1 .341-.649.96.96 0 0 1 .578-.309 1.1 1.1 0 0 1 1.043.3 2.4 2.4 0 0 1 .546 1.03l.517-.083.018.113-.507.082.041.22a2 2 0 0 1-.076.955.71.71 0 0 1-.574.549.56.56 0 0 1-.424-.1.55.55 0 0 1-.235-.372.6.6 0 0 1 .08-.433.5.5 0 0 1 .367-.225.43.43 0 0 1 .35.076.53.53 0 0 1 .186.263q.013.085.079.076c.066-.009.089-.105.125-.292a1.4 1.4 0 0 0 .019-.5l-.038-.2-1.3.211q-.049.212-.1.442t-.132.466a1.2 1.2 0 0 1-.333.474 1.1 1.1 0 0 1-.6.293 1.05 1.05 0 0 1-1-.345 1.8 1.8 0 0 1-.486-.936l-.328.053-.019-.113Zm.142.093a.68.68 0 0 0 .246.324.52.52 0 0 0 .382.072.57.57 0 0 0 .361-.192 1.2 1.2 0 0 0 .207-.4Zm3.8-.7a1 1 0 0 0-.25-.413.46.46 0 0 0-.413-.116.58.58 0 0 0-.359.183 1.35 1.35 0 0 0-.222.547Z",
    "data-name": "Path 14225"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#505c2d",
    d: "M43.213 2.235a.674.674 0 1 1-.557.772.674.674 0 0 1 .557-.772",
    "data-name": "Path 14226"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#505c2d",
    d: "M44.524 10.361a.674.674 0 1 1-.558.773.674.674 0 0 1 .558-.773",
    "data-name": "Path 14227"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9159",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9158"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__l)",
    "data-name": "Group 9157",
    transform: "translate(39.863 .282)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b7c6c8",
    d: "m6.231 0 1.986 12.309L0 1.009Z",
    "data-name": "Path 14228"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M40.139 11.941 43.726.001l6.044 1.816-3.587 11.94z",
    "data-name": "Rectangle 558"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "m47.934 2.122-2.844-.855a.99.99 0 0 1-1.233.663l-2.505 8.34a.99.99 0 0 1 .663 1.233 1 1 0 0 1-.05.129l2.865.86a1 1 0 0 1 .029-.135.99.99 0 0 1 1.233-.664l2.506-8.34a.99.99 0 0 1-.664-1.233",
    "data-name": "Path 14229"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "M45.743 4.254a2.738 2.738 0 1 1-3.411 1.835 2.74 2.74 0 0 1 3.411-1.835",
    "data-name": "Path 14230"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f7f8",
    d: "m42.926 6.188.025-.084a1.8 1.8 0 0 1 .482-.845.7.7 0 0 1 .709-.159.5.5 0 0 1 .313.257.52.52 0 0 1 .039.41.6.6 0 0 1-.24.334.45.45 0 0 1-.405.05.5.5 0 0 1-.3-.219.4.4 0 0 1-.077-.274c.014-.078 0-.122-.032-.132s-.1.04-.184.158a1.3 1.3 0 0 0-.181.376l-.042.158 1.223.367q.248-.309.489-.62a1.6 1.6 0 0 1 .591-.435.96.96 0 0 1 .655-.026 1.1 1.1 0 0 1 .807.726 2.4 2.4 0 0 1 .041 1.165l.5.151-.033.109-.491-.148-.059.216a2.04 2.04 0 0 1-.486.826.71.71 0 0 1-.757.243.56.56 0 0 1-.338-.277.55.55 0 0 1-.048-.437.6.6 0 0 1 .261-.355.51.51 0 0 1 .429-.042.43.43 0 0 1 .281.221.54.54 0 0 1 .052.318c-.017.056 0 .09.038.1s.126-.055.24-.209a1.4 1.4 0 0 0 .233-.437l.054-.2-1.265-.38-.285.353q-.15.183-.323.362a1.2 1.2 0 0 1-.505.281 1.12 1.12 0 0 1-.668 0 1.05 1.05 0 0 1-.747-.746 1.8 1.8 0 0 1-.028-1.054l-.319-.1.033-.11Zm.087.146a.67.67 0 0 0 .08.4.5.5 0 0 0 .312.232.57.57 0 0 0 .409-.015 1.2 1.2 0 0 0 .359-.267Zm3.719 1.032a1 1 0 0 0-.045-.48.46.46 0 0 0-.321-.285.58.58 0 0 0-.4.007 1.36 1.36 0 0 0-.439.4Z",
    "data-name": "Path 14231"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#505c2d",
    d: "M46.326 2.314a.674.674 0 1 1-.839.451.673.673 0 0 1 .839-.451",
    "data-name": "Path 14232"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#505c2d",
    d: "M43.957 10.198a.674.674 0 1 1-.839.451.674.674 0 0 1 .839-.451",
    "data-name": "Path 14233"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9162",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9161"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__m)",
    "data-name": "Group 9160",
    transform: "translate(43.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b7c6c8",
    d: "m6.045 1.816-3.587 11.94L.001-.001Z",
    "data-name": "Path 14234"
  }))))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M40.414 10.875 47.97.963l5.018 3.825-7.556 9.912z",
    "data-name": "Rectangle 560"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "m51.167 4.428-2.362-1.8a.99.99 0 0 1-1.388.187l-5.28 6.924a.99.99 0 0 1 .187 1.388 1 1 0 0 1-.092.1l2.378 1.814a1 1 0 0 1 .075-.115.99.99 0 0 1 1.388-.188l5.28-6.924a.99.99 0 0 1-.187-1.388",
    "data-name": "Path 14235"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "M48.365 5.654a2.738 2.738 0 1 1-3.838.517 2.74 2.74 0 0 1 3.838-.517",
    "data-name": "Path 14236"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#707e3d",
    d: "m45.047 6.471.053-.07a1.8 1.8 0 0 1 .748-.621.7.7 0 0 1 .72.1.5.5 0 0 1 .2.351.52.52 0 0 1-.107.4.6.6 0 0 1-.342.229.46.46 0 0 1-.4-.1.51.51 0 0 1-.206-.311.4.4 0 0 1 .025-.284q.06-.101.017-.135c-.043-.034-.111 0-.229.084a1.3 1.3 0 0 0-.3.288l-.1.134 1.015.774q.34-.2.676-.408a1.6 1.6 0 0 1 .706-.2.96.96 0 0 1 .623.206 1.1 1.1 0 0 1 .5.964 2.4 2.4 0 0 1-.372 1.1l.417.318-.069.091-.408-.311-.132.181a2 2 0 0 1-.745.6.71.71 0 0 1-.794-.039.56.56 0 0 1-.218-.377.55.55 0 0 1 .108-.427.6.6 0 0 1 .369-.24.5.5 0 0 1 .416.111.43.43 0 0 1 .186.306.53.53 0 0 1-.063.316q-.052.07 0 .109c.052.039.138-.008.3-.111a1.4 1.4 0 0 0 .372-.327l.12-.167-1.05-.8-.392.23q-.2.118-.429.225a1.2 1.2 0 0 1-.573.085 1.12 1.12 0 0 1-.625-.233 1.05 1.05 0 0 1-.437-.961 1.8 1.8 0 0 1 .345-1l-.264-.2.069-.091Zm.031.167a.67.67 0 0 0-.066.4.52.52 0 0 0 .211.327.57.57 0 0 0 .388.13 1.2 1.2 0 0 0 .43-.124Zm3.118 2.275a1 1 0 0 0 .128-.466.46.46 0 0 0-.2-.379.58.58 0 0 0-.38-.135 1.4 1.4 0 0 0-.55.216Z",
    "data-name": "Path 14237"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#505c2d",
    d: "M49.589 4.042a.674.674 0 1 1-.944.127.673.673 0 0 1 .944-.127",
    "data-name": "Path 14238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M44.602 10.588a.674.674 0 1 1-.944.127.674.674 0 0 1 .944-.127",
    "data-name": "Path 14239"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9165",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9164"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__n)",
    "data-name": "Group 9163",
    transform: "translate(45.434 .961)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M7.56 3.827 0 13.742 2.541.001Z",
    "data-name": "Path 14240"
  }))))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#562c0c",
    d: "M48.676 13.785a.89.89 0 0 1-.895.883l-10.262-.066a.89.89 0 0 1-.883-.895l.049-7.038a.89.89 0 0 1 .894-.884l10.262.066a.89.89 0 0 1 .883.9Z",
    "data-name": "Path 14241"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#62320f",
    d: "M48.193 13.498a.82.82 0 0 1-.823.812l-9.437-.056a.82.82 0 0 1-.813-.823l.041-6.472a.82.82 0 0 1 .823-.812l9.435.061a.817.817 0 0 1 .812.822Z",
    "data-name": "Path 14242"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#311a00",
    strokeDasharray: "1.616 1.616",
    strokeWidth: 0.408,
    d: "M47.729 13.223a.75.75 0 0 1-.753.744l-8.642-.056a.75.75 0 0 1-.744-.753l.038-5.927a.75.75 0 0 1 .753-.744l8.642.055a.75.75 0 0 1 .743.754Z",
    "data-name": "Path 14243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9168",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9167"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__o)",
    "data-name": "Group 9166",
    transform: "translate(40.371 5.803)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#facdc1",
    d: "M.085.696a1.57 1.57 0 0 0 1.259.868 4.4 4.4 0 0 0 1.674.031 10.2 10.2 0 0 1 3.018-.326c1.7.25 1.812 1.333 2.308.687L8.352.79a.81.81 0 0 0-.858-.743L.014-.001a1.5 1.5 0 0 0 .071.7",
    "data-name": "Path 14244"
  }))))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#512a0b",
    d: "M48.986 10.924a.783.783 0 0 1-.788.778l-4.745-.031a.78.78 0 0 1-.778-.788l.011-1.729a.783.783 0 0 1 .788-.778l4.745.031a.783.783 0 0 1 .778.788Z",
    "data-name": "Path 14245"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#62320f",
    d: "M48.695 10.785a.67.67 0 0 1-.689.655l-4.152-.026a.673.673 0 0 1-.681-.664l.009-1.457a.673.673 0 0 1 .689-.655l4.152.027a.67.67 0 0 1 .681.664Z",
    "data-name": "Path 14246"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#311a00",
    strokeDasharray: "1.631 1.631",
    strokeWidth: 0.408,
    d: "m48.639 11.171-4.6-.029a.563.563 0 0 1-.587-.533l.008-1.168a.56.56 0 0 1 .593-.526l4.6.029",
    "data-name": "Path 14247"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd400",
    d: "M45.23 10.073a.743.743 0 1 1-.738-.748.74.74 0 0 1 .738.748",
    "data-name": "Path 14248"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc9d00",
    d: "M44.701 10.534a.74.74 0 0 1-.671-1.05.742.742 0 1 0 1.132.892.74.74 0 0 1-.461.158",
    "data-name": "Path 14249"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9171",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9170"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__p)",
    "data-name": "Group 9169",
    transform: "translate(36.636 5.785)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdbabe",
    d: "M11.849 4.947a6.95 6.95 0 0 1-5.6 1.4 5.13 5.13 0 0 1-2.835-1.169A4.9 4.9 0 0 1 1.996 2.54 11 11 0 0 1 1.855.008L.938.002a.89.89 0 0 0-.889.881L.004 7.922a.89.89 0 0 0 .883.895l10.262.066A.89.89 0 0 0 12.044 8l.021-3.241a6 6 0 0 1-.214.188",
    "data-name": "Path 14250"
  }))))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M83.39 45.805a5.63 5.63 0 0 0-5.665-.036l-.827-.005-.009 1.559h.025c.205 1.035 1.746 1.847 3.622 1.859s3.426-.78 3.646-1.813h.025l.009-1.56Z",
    "data-name": "Path 14251"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66600",
    d: "M78.876 45.247a4 4 0 0 0-1.152.522l-.827-.005-.009 1.559h.025a2.54 2.54 0 0 0 1.938 1.615Z",
    "data-name": "Path 14252"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M80.279 45.028h-.1l-.027 4.136.1.006Z",
    "data-name": "Path 14253"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M80.871 45.033q-.058.001-.118-.005l-.027 4.153h.119Z",
    "data-name": "Path 14254"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M82.035 45.212q-.068-.019-.138-.034l-.025 3.871.139-.034Z",
    "data-name": "Path 14255"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.193 45.681c-.052-.031-.1-.06-.158-.089l-.02 3.053q.082-.043.159-.087Z",
    "data-name": "Path 14256"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.849 45.808h-.139l-.015 2.37c.05-.048.1-.1.139-.147Z",
    "data-name": "Path 14257"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M81.641 45.126q-.048-.01-.1-.019l-.025 4.007.1-.017Z",
    "data-name": "Path 14258"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M81.505 45.101a6 6 0 0 0-.434-.053l-.027 4.119q.222-.017.435-.048Z",
    "data-name": "Path 14259"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc200",
    d: "M84.215 45.981c-.007 1.148-1.651 2.069-3.673 2.057s-3.653-.955-3.645-2.1 1.652-2.069 3.673-2.056 3.653.955 3.645 2.1",
    "data-name": "Path 14260"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9174",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9173"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__q)",
    "data-name": "Group 9172",
    transform: "translate(79.028 44.012)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.211 1.524a2.72 2.72 0 0 0 2.351-.6 4 4 0 0 0 .3-.381A4.45 4.45 0 0 0 1.544.004 6 6 0 0 0 .049.172 1 1 0 0 0 .03.238c-.153.584.3 1.153 1.181 1.29",
    "data-name": "Path 14261"
  }))))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.271 46.334a3.39 3.39 0 0 1-3.708.759 2.456 2.456 0 0 1-1.4-2.72 1.91 1.91 0 0 0-1.271 1.561c-.007 1.149 1.625 2.09 3.646 2.1s3.666-.908 3.673-2.057a1.33 1.33 0 0 0-.25-.764 4.6 4.6 0 0 1-.691 1.115",
    "data-name": "Path 14262"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9177",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9176"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__r)",
    "data-name": "Group 9175",
    transform: "translate(77.667 45.007)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.974C1.544 1.964.273 1.291.278.474A.87.87 0 0 1 .426.007 1.04 1.04 0 0 0 0 .782c-.006.82 1.265 1.493 2.838 1.5a3.3 3.3 0 0 0 2.708-1 3.9 3.9 0 0 1-2.43.692",
    "data-name": "Path 14263"
  }))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#f17800",
    d: "M80.305 44.561a.12.12 0 0 1 .033-.064 2 2 0 0 1 .176-.139c.022-.011-.073.079-.047.074l.079-.013a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .019.032v.041q.001.014-.005.027c-.006.013 0 .017-.006.027l-.027.23a2.5 2.5 0 0 1 .35.051 1.6 1.6 0 0 1 .291.1.7.7 0 0 1 .2.126.2.2 0 0 1 .072.147c0 .026.092-.025.077 0a1.3 1.3 0 0 1-.16.132.4.4 0 0 1-.09.039.4.4 0 0 1-.1.014 5 5 0 0 1-.149-.133 1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.094 1 1 0 0 0-.271-.036.6.6 0 0 0-.123.012 1 1 0 0 0-.117.033.3.3 0 0 0-.087.052.09.09 0 0 0-.034.066.24.24 0 0 0 .093.17 1.1 1.1 0 0 0 .287.171l.432.189a3 3 0 0 1 .342.169 1 1 0 0 1 .227.174.3.3 0 0 1 .082.205.3.3 0 0 1-.073.188.7.7 0 0 1-.2.157 1.3 1.3 0 0 1-.292.113 2 2 0 0 1-.356.059c0 .126.1.129.094.161a.33.33 0 0 1-.331.222.1.1 0 0 1-.084-.038.2.2 0 0 1-.04-.1.6.6 0 0 1-.011-.125v-.128a1.2 1.2 0 0 1-.256-.054 2 2 0 0 1-.244-.1 1 1 0 0 1-.185-.13.18.18 0 0 1-.072-.128.12.12 0 0 1 .023-.07 3 3 0 0 1 .209-.174c.027-.018-.039.128-.005.118s.015-.063.051-.062a.1.1 0 0 1 .06.027.5.5 0 0 1 .074.072 1 1 0 0 0 .135.131.7.7 0 0 0 .145.085.7.7 0 0 0 .163.047 1.4 1.4 0 0 0 .188.015 1 1 0 0 0 .145-.012.7.7 0 0 0 .128-.034.3.3 0 0 0 .091-.051.1.1 0 0 0 .034-.066c0-.094-.126-.2-.379-.308q-.238-.1-.438-.192a3 3 0 0 1-.345-.179 1 1 0 0 1-.226-.184.3.3 0 0 1-.08-.206.28.28 0 0 1 .072-.175 1.5 1.5 0 0 1 .258-.226c.075-.046.081-.015.171-.046a1 1 0 0 1 .26-.059v-.114l-.008-.047a.2.2 0 0 1 .009-.091",
    "data-name": "Path 14264"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc800",
    d: "M80.423 44.463a.14.14 0 0 1 .034-.065.2.2 0 0 1 .058-.041.3.3 0 0 1 .073-.024l.078-.013a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .018.032v.041q.001.013-.005.028l-.006.027-.027.23a2.4 2.4 0 0 1 .35.051 1.5 1.5 0 0 1 .29.1.7.7 0 0 1 .2.126.2.2 0 0 1 .073.148.13.13 0 0 1-.023.071.2.2 0 0 1-.062.058.4.4 0 0 1-.089.04.4.4 0 0 1-.105.014 3 3 0 0 1-.148-.134 1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.092 1 1 0 0 0-.266-.038.7.7 0 0 0-.124.012.6.6 0 0 0-.116.034.3.3 0 0 0-.089.051.09.09 0 0 0-.035.067.24.24 0 0 0 .093.17 1.1 1.1 0 0 0 .286.172l.432.188a3 3 0 0 1 .343.169.9.9 0 0 1 .226.175.29.29 0 0 1 .008.393.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.292.114 2 2 0 0 1-.355.058 1 1 0 0 1-.017.237.2.2 0 0 1-.22.146.1.1 0 0 1-.084-.038.3.3 0 0 1-.04-.095.5.5 0 0 1-.011-.125v-.128a1.2 1.2 0 0 1-.255-.054 1.5 1.5 0 0 1-.245-.1.8.8 0 0 1-.183-.125.18.18 0 0 1-.073-.127.12.12 0 0 1 .024-.07.3.3 0 0 1 .063-.061.4.4 0 0 1 .09-.042.3.3 0 0 1 .1-.015.1.1 0 0 1 .059.026.5.5 0 0 1 .076.072 1 1 0 0 0 .135.13.7.7 0 0 0 .145.087.8.8 0 0 0 .163.046 1.3 1.3 0 0 0 .188.015 1 1 0 0 0 .145-.012.7.7 0 0 0 .127-.035.3.3 0 0 0 .091-.051.09.09 0 0 0 .034-.066c0-.094-.125-.2-.378-.309-.158-.067-.3-.131-.438-.19a3 3 0 0 1-.345-.18 1 1 0 0 1-.225-.183.3.3 0 0 1-.079-.207.28.28 0 0 1 .071-.176.7.7 0 0 1 .183-.155 1.2 1.2 0 0 1 .245-.116 1.1 1.1 0 0 1 .262-.059v-.113s0-.019-.007-.046a.3.3 0 0 1 .008-.09",
    "data-name": "Path 14265"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M83.401 44.318a5.64 5.64 0 0 0-5.666-.037l-.826-.005-.011 1.561h.026c.2 1.035 1.746 1.847 3.621 1.859s3.427-.78 3.645-1.812h.026l.01-1.561Z",
    "data-name": "Path 14266"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66600",
    d: "M78.886 43.76a4 4 0 0 0-1.152.521h-.826l-.01 1.56h.026a2.54 2.54 0 0 0 1.938 1.614Z",
    "data-name": "Path 14267"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M80.288 43.542h-.1l-.026 4.136.1.006Z",
    "data-name": "Path 14268"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m80.881 43.547-.118-.006-.027 4.154h.119Z",
    "data-name": "Path 14269"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M82.044 43.725q-.068-.018-.137-.034l-.025 3.87q.07-.014.138-.033Z",
    "data-name": "Path 14270"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.208 44.194c-.052-.03-.1-.06-.157-.089l-.02 3.054q.082-.043.158-.088Z",
    "data-name": "Path 14271"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.858 44.321h-.138l-.016 2.371c.05-.048.1-.1.14-.147Z",
    "data-name": "Path 14272"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M81.65 43.639q-.048-.01-.1-.018l-.026 4.006.1-.016Z",
    "data-name": "Path 14273"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M81.512 43.614q-.212-.033-.434-.053l-.026 4.119q.221-.016.435-.048Z",
    "data-name": "Path 14274"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc200",
    d: "M84.226 44.496c-.008 1.148-1.652 2.069-3.672 2.056s-3.654-.954-3.646-2.1 1.652-2.069 3.673-2.057 3.653.954 3.646 2.1",
    "data-name": "Path 14275"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9180",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9179"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__s)",
    "data-name": "Group 9178",
    transform: "translate(79.037 42.526)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.211 1.524a2.72 2.72 0 0 0 2.352-.6 5 5 0 0 0 .3-.381A4.46 4.46 0 0 0 1.545.005a6 6 0 0 0-1.5.168L.026.239c-.154.583.3 1.153 1.182 1.29",
    "data-name": "Path 14276"
  }))))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.285 44.848a3.39 3.39 0 0 1-3.708.759 2.46 2.46 0 0 1-1.4-2.719 1.91 1.91 0 0 0-1.271 1.561c-.007 1.149 1.625 2.09 3.647 2.1s3.664-.907 3.672-2.056a1.33 1.33 0 0 0-.249-.764 4.6 4.6 0 0 1-.691 1.115",
    "data-name": "Path 14277"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9183",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9182"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__t)",
    "data-name": "Group 9181",
    transform: "translate(77.676 43.521)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.969C1.544 1.959.272 1.286.278.469A.87.87 0 0 1 .425.003 1.04 1.04 0 0 0 0 .778c-.005.82 1.266 1.493 2.838 1.5a3.3 3.3 0 0 0 2.709-1 3.9 3.9 0 0 1-2.43.693",
    "data-name": "Path 14278"
  }))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#f17800",
    d: "M80.32 43.074a.14.14 0 0 1 .033-.064 2 2 0 0 1 .176-.139c.023-.01-.073.08-.046.074l.078-.013a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.1.1 0 0 1 .018.031v.041l-.005.027q.001.012-.005.028l-.028.23a2.3 2.3 0 0 1 .351.052 1.5 1.5 0 0 1 .291.094.7.7 0 0 1 .2.126.2.2 0 0 1 .071.147c0 .026.092-.025.077 0a1.4 1.4 0 0 1-.161.132.4.4 0 0 1-.089.039.4.4 0 0 1-.1.014 4 4 0 0 1-.149-.134 1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.092.9.9 0 0 0-.271-.037.6.6 0 0 0-.123.012 1 1 0 0 0-.117.033.3.3 0 0 0-.088.052.09.09 0 0 0-.034.066.24.24 0 0 0 .092.171 1.1 1.1 0 0 0 .286.171q.234.105.433.189a3 3 0 0 1 .343.169 1 1 0 0 1 .226.174.29.29 0 0 1 .008.393.7.7 0 0 1-.2.157 1.3 1.3 0 0 1-.292.114 2 2 0 0 1-.356.058c0 .126.105.129.094.162a.33.33 0 0 1-.331.222.1.1 0 0 1-.084-.038.2.2 0 0 1-.04-.1 1 1 0 0 1-.011-.125v-.127a1.3 1.3 0 0 1-.255-.055 2 2 0 0 1-.244-.1 1 1 0 0 1-.183-.125.18.18 0 0 1-.072-.127.12.12 0 0 1 .024-.071 2 2 0 0 1 .209-.174c.025-.018-.039.127-.006.117s.017-.063.052-.063a.1.1 0 0 1 .06.026.4.4 0 0 1 .075.072 1 1 0 0 0 .135.131.7.7 0 0 0 .143.085.7.7 0 0 0 .164.047 1 1 0 0 0 .188.015.7.7 0 0 0 .145-.012.7.7 0 0 0 .128-.033.3.3 0 0 0 .091-.052.1.1 0 0 0 .035-.066c0-.094-.126-.2-.381-.308l-.437-.192a3 3 0 0 1-.346-.179 1 1 0 0 1-.224-.184.3.3 0 0 1-.081-.206.28.28 0 0 1 .072-.175 1.5 1.5 0 0 1 .259-.225c.075-.046.08-.016.17-.047a1 1 0 0 1 .26-.059v-.114s0-.02-.008-.046a.3.3 0 0 1 .009-.092",
    "data-name": "Path 14279"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc800",
    d: "M80.433 42.977a.13.13 0 0 1 .033-.064.3.3 0 0 1 .058-.041.4.4 0 0 1 .073-.024q.04-.008.078-.013a.3.3 0 0 1 .09 0 .1.1 0 0 1 .049.024.05.05 0 0 1 .017.031v.042q.001.014-.005.026c-.006.012 0 .018-.005.028l-.028.23a2.3 2.3 0 0 1 .351.052 1.5 1.5 0 0 1 .29.095.7.7 0 0 1 .2.126.2.2 0 0 1 .072.147.12.12 0 0 1-.023.071.2.2 0 0 1-.062.058.4.4 0 0 1-.089.04.4.4 0 0 1-.1.013 5 5 0 0 1-.149-.133 1 1 0 0 0-.157-.124.8.8 0 0 0-.2-.093.9.9 0 0 0-.27-.036.6.6 0 0 0-.123.011.6.6 0 0 0-.117.035.3.3 0 0 0-.087.051.1.1 0 0 0-.035.067.24.24 0 0 0 .094.17 1.1 1.1 0 0 0 .285.171q.234.104.433.189a3 3 0 0 1 .342.169 1 1 0 0 1 .226.175.3.3 0 0 1 .081.206.3.3 0 0 1-.073.187.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.292.113 2 2 0 0 1-.356.058 1 1 0 0 1-.017.237.2.2 0 0 1-.221.146.1.1 0 0 1-.084-.037.2.2 0 0 1-.04-.1.6.6 0 0 1-.011-.125v-.127a1.3 1.3 0 0 1-.256-.055 1.6 1.6 0 0 1-.243-.1 1 1 0 0 1-.184-.125.18.18 0 0 1-.071-.127.12.12 0 0 1 .023-.07.3.3 0 0 1 .063-.06.4.4 0 0 1 .09-.043.3.3 0 0 1 .1-.015.1.1 0 0 1 .061.026 1 1 0 0 1 .075.071 1 1 0 0 0 .135.132.7.7 0 0 0 .307.132 1 1 0 0 0 .188.015 1 1 0 0 0 .145-.012.6.6 0 0 0 .128-.035.3.3 0 0 0 .09-.051.09.09 0 0 0 .035-.066c0-.094-.126-.2-.38-.309q-.237-.1-.437-.19a3 3 0 0 1-.345-.18 1 1 0 0 1-.224-.184.3.3 0 0 1-.08-.206.28.28 0 0 1 .072-.176.7.7 0 0 1 .183-.156 1.2 1.2 0 0 1 .245-.116 1 1 0 0 1 .26-.059v-.113a.3.3 0 0 1-.007-.046.2.2 0 0 1 .008-.091",
    "data-name": "Path 14280"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M83.408 42.848a5.64 5.64 0 0 0-5.665-.036l-.827-.006-.01 1.561h.026c.206 1.035 1.746 1.848 3.621 1.86s3.426-.781 3.646-1.813h.025l.011-1.56Z",
    "data-name": "Path 14281"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66600",
    d: "M78.895 42.289a4 4 0 0 0-1.152.522l-.827-.006-.01 1.56h.026a2.55 2.55 0 0 0 1.938 1.616Z",
    "data-name": "Path 14282"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M80.298 42.071h-.1l-.027 4.136.1.005Z",
    "data-name": "Path 14283"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m80.89 42.076-.118-.005-.027 4.153h.119Z",
    "data-name": "Path 14284"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m82.054 42.255-.138-.035-.025 3.87q.07-.015.138-.033Z",
    "data-name": "Path 14285"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.216 42.724c-.052-.03-.1-.06-.157-.089l-.02 3.054q.082-.043.159-.088Z",
    "data-name": "Path 14286"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.866 42.851h-.138l-.014 2.369c.05-.047.1-.1.139-.146Z",
    "data-name": "Path 14287"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m81.66 42.168-.1-.018-.026 4.006c.033 0 .067-.01.1-.016Z",
    "data-name": "Path 14288"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M81.523 42.143a6 6 0 0 0-.435-.053l-.026 4.118q.22-.017.435-.047Z",
    "data-name": "Path 14289"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc200",
    d: "M84.235 43.024c-.008 1.15-1.651 2.07-3.673 2.057s-3.653-.954-3.646-2.1 1.652-2.069 3.673-2.056 3.654.954 3.646 2.1",
    "data-name": "Path 14290"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9186",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9185"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__u)",
    "data-name": "Group 9184",
    transform: "translate(79.046 41.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.211 1.523a2.72 2.72 0 0 0 2.351-.6 5 5 0 0 0 .3-.382A4.45 4.45 0 0 0 1.544.003a6 6 0 0 0-1.5.167l-.02.067c-.153.583.3 1.153 1.182 1.289",
    "data-name": "Path 14291"
  }))))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.293 43.376a3.39 3.39 0 0 1-3.708.759 2.455 2.455 0 0 1-1.4-2.719 1.91 1.91 0 0 0-1.272 1.562c-.007 1.149 1.625 2.091 3.647 2.1s3.666-.907 3.673-2.057a1.33 1.33 0 0 0-.25-.763 4.6 4.6 0 0 1-.691 1.115",
    "data-name": "Path 14292"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9189",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9188"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__t)",
    "data-name": "Group 9187",
    transform: "translate(77.686 42.051)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.969C1.543 1.959.273 1.287.278.469A.87.87 0 0 1 .426.004a1.03 1.03 0 0 0-.425.774c-.005.82 1.264 1.493 2.837 1.5a3.3 3.3 0 0 0 2.709-1 3.9 3.9 0 0 1-2.431.691",
    "data-name": "Path 14293"
  }))))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#f17800",
    d: "M80.324 41.604a.12.12 0 0 1 .033-.064 2 2 0 0 1 .176-.14c.022-.01-.073.079-.047.074l.079-.013a.3.3 0 0 1 .089 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .018.032v.068l-.006.027-.026.231a2 2 0 0 1 .35.052 1.5 1.5 0 0 1 .291.095.7.7 0 0 1 .2.125.2.2 0 0 1 .073.147c0 .025.091-.025.077 0a1 1 0 0 1-.162.132.3.3 0 0 1-.089.039.3.3 0 0 1-.1.014q-.078-.065-.15-.133a1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.092.9.9 0 0 0-.272-.037.6.6 0 0 0-.122.011 1 1 0 0 0-.116.034.3.3 0 0 0-.088.051.1.1 0 0 0-.034.067.23.23 0 0 0 .093.169 1 1 0 0 0 .286.172l.433.189a3 3 0 0 1 .342.168 1 1 0 0 1 .227.175.3.3 0 0 1 .08.205.3.3 0 0 1-.073.188.6.6 0 0 1-.2.157 1.4 1.4 0 0 1-.292.114 2 2 0 0 1-.356.058c0 .125.1.129.095.161a.33.33 0 0 1-.332.223.1.1 0 0 1-.083-.039.2.2 0 0 1-.041-.1.6.6 0 0 1-.011-.125v-.127a1.2 1.2 0 0 1-.256-.055 1.5 1.5 0 0 1-.242-.1.9.9 0 0 1-.184-.124.18.18 0 0 1-.072-.128.13.13 0 0 1 .023-.07 3 3 0 0 1 .21-.175c.026-.018-.04.127-.006.118s.016-.062.05-.062a.1.1 0 0 1 .061.026.5.5 0 0 1 .076.073 1 1 0 0 0 .134.13.7.7 0 0 0 .145.085.7.7 0 0 0 .163.047 1.4 1.4 0 0 0 .188.015 1 1 0 0 0 .145-.012.6.6 0 0 0 .129-.034.3.3 0 0 0 .09-.051.1.1 0 0 0 .035-.066c0-.094-.126-.2-.38-.309-.157-.067-.3-.13-.438-.191a3 3 0 0 1-.345-.18 1 1 0 0 1-.225-.183.3.3 0 0 1-.079-.206.28.28 0 0 1 .072-.176 1.6 1.6 0 0 1 .259-.225c.075-.046.081-.015.17-.047a1 1 0 0 1 .26-.058v-.113a.2.2 0 0 1-.008-.048.3.3 0 0 1 .008-.09",
    "data-name": "Path 14294"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc800",
    d: "M80.443 41.506a.13.13 0 0 1 .033-.065.2.2 0 0 1 .058-.041.3.3 0 0 1 .072-.023l.078-.013a.3.3 0 0 1 .091 0 .1.1 0 0 1 .048.022.05.05 0 0 1 .018.032v.042q.001.014-.005.027v.027l-.028.231a3 3 0 0 1 .352.051 1.6 1.6 0 0 1 .29.095.7.7 0 0 1 .2.127.2.2 0 0 1 .073.147.13.13 0 0 1-.024.071.2.2 0 0 1-.061.058.3.3 0 0 1-.089.039.4.4 0 0 1-.1.014 5 5 0 0 1-.149-.133 1 1 0 0 0-.157-.124.8.8 0 0 0-.2-.093 1 1 0 0 0-.271-.037 1 1 0 0 0-.123.012 1 1 0 0 0-.117.033.3.3 0 0 0-.088.052.1.1 0 0 0-.035.066.23.23 0 0 0 .093.17 1 1 0 0 0 .287.171q.234.105.432.19a3 3 0 0 1 .343.169 1 1 0 0 1 .226.174.29.29 0 0 1 .008.393.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.292.114 2 2 0 0 1-.355.057 1 1 0 0 1-.018.237.2.2 0 0 1-.22.147.1.1 0 0 1-.083-.038.24.24 0 0 1-.041-.1 1 1 0 0 1-.01-.125v-.128a1.2 1.2 0 0 1-.256-.055 1.5 1.5 0 0 1-.243-.1.9.9 0 0 1-.184-.124.19.19 0 0 1-.073-.128.12.12 0 0 1 .025-.07.2.2 0 0 1 .063-.06.4.4 0 0 1 .09-.043.3.3 0 0 1 .1-.016.1.1 0 0 1 .06.027.4.4 0 0 1 .076.072 1 1 0 0 0 .135.131.7.7 0 0 0 .144.085.7.7 0 0 0 .163.048 1.3 1.3 0 0 0 .188.014 1 1 0 0 0 .145-.011 1 1 0 0 0 .128-.035.3.3 0 0 0 .09-.051.09.09 0 0 0 .034-.066c0-.094-.125-.2-.379-.309q-.234-.1-.436-.191a3 3 0 0 1-.346-.179 1 1 0 0 1-.225-.183.3.3 0 0 1-.079-.206.28.28 0 0 1 .071-.176.7.7 0 0 1 .182-.156 1.2 1.2 0 0 1 .247-.117 1 1 0 0 1 .26-.058v-.114q.002-.007-.008-.046a.3.3 0 0 1 .009-.091",
    "data-name": "Path 14295"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M83.419 41.362a5.64 5.64 0 0 0-5.666-.036l-.827-.005-.01 1.559h.026c.206 1.035 1.746 1.847 3.621 1.859s3.426-.781 3.646-1.813h.026l.01-1.56Z",
    "data-name": "Path 14296"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66600",
    d: "M78.906 40.803a4 4 0 0 0-1.152.522l-.827-.005-.01 1.559h.026a2.55 2.55 0 0 0 1.938 1.615Z",
    "data-name": "Path 14297"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M80.307 40.588h-.1l-.027 4.137h.1Z",
    "data-name": "Path 14298"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m80.9 40.589-.118-.006-.026 4.154h.118Z",
    "data-name": "Path 14299"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M82.064 40.769q-.068-.018-.139-.035l-.025 3.87q.07-.016.139-.033Z",
    "data-name": "Path 14300"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.226 41.238c-.052-.032-.1-.062-.157-.09l-.019 3.053q.08-.043.158-.088Z",
    "data-name": "Path 14301"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M83.877 41.364h-.139l-.014 2.37c.05-.048.1-.1.139-.146Z",
    "data-name": "Path 14302"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m81.67 40.681-.1-.019-.026 4.007.1-.016Z",
    "data-name": "Path 14303"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M81.531 40.657a7 7 0 0 0-.433-.053l-.027 4.118q.222-.016.435-.046Z",
    "data-name": "Path 14304"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M84.244 41.538c-.007 1.148-1.652 2.069-3.673 2.056s-3.653-.955-3.646-2.1 1.652-2.069 3.673-2.056 3.654.955 3.646 2.1",
    "data-name": "Path 14305"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9192",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9191"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__v)",
    "data-name": "Group 9190",
    transform: "translate(79.056 39.569)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.21 1.523a2.72 2.72 0 0 0 2.352-.6 5 5 0 0 0 .3-.381A4.46 4.46 0 0 0 1.543.004a6 6 0 0 0-1.5.167l-.02.066c-.153.583.3 1.153 1.181 1.29",
    "data-name": "Path 14306"
  }))))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#d54a4b",
    d: "M83.303 41.89a3.385 3.385 0 0 1-3.707.759 2.456 2.456 0 0 1-1.4-2.72 1.91 1.91 0 0 0-1.272 1.562c-.007 1.148 1.626 2.091 3.647 2.1s3.666-.908 3.673-2.056a1.34 1.34 0 0 0-.25-.765 4.6 4.6 0 0 1-.691 1.116",
    "data-name": "Path 14307"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9195",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9194"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__t)",
    "data-name": "Group 9193",
    transform: "translate(77.695 40.564)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.969C1.544 1.959.273 1.286.278.469A.87.87 0 0 1 .426.003 1.03 1.03 0 0 0 0 .777c-.005.82 1.265 1.493 2.837 1.5a3.3 3.3 0 0 0 2.71-1 3.9 3.9 0 0 1-2.431.692",
    "data-name": "Path 14308"
  }))))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M80.334 40.118a.12.12 0 0 1 .034-.064 2 2 0 0 1 .176-.14c.023-.01-.072.079-.046.074l.078-.014a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.1.1 0 0 1 .018.032v.069l-.006.027-.028.23a2 2 0 0 1 .351.052 1.6 1.6 0 0 1 .291.094.7.7 0 0 1 .2.126.2.2 0 0 1 .072.148c0 .025.092-.026.077 0a1.3 1.3 0 0 1-.161.132.3.3 0 0 1-.089.039.4.4 0 0 1-.1.013 4 4 0 0 1-.149-.132 1 1 0 0 0-.157-.124.8.8 0 0 0-.2-.093 1 1 0 0 0-.278-.043.6.6 0 0 0-.123.011 1 1 0 0 0-.117.034.3.3 0 0 0-.087.052.09.09 0 0 0-.035.067.24.24 0 0 0 .093.169 1 1 0 0 0 .287.171q.234.105.432.19a3 3 0 0 1 .342.168.9.9 0 0 1 .227.175.3.3 0 0 1 .081.2.3.3 0 0 1-.073.188.6.6 0 0 1-.2.158 1.4 1.4 0 0 1-.293.114 2 2 0 0 1-.355.058c0 .125.105.13.095.162a.33.33 0 0 1-.332.222.1.1 0 0 1-.083-.039.2.2 0 0 1-.04-.1.6.6 0 0 1-.012-.125v-.127a1.2 1.2 0 0 1-.256-.055 2 2 0 0 1-.244-.1 1 1 0 0 1-.182-.125.18.18 0 0 1-.074-.128.12.12 0 0 1 .025-.07 3 3 0 0 1 .209-.175c.027-.018-.04.128-.006.117s.016-.061.051-.061a.1.1 0 0 1 .06.026.5.5 0 0 1 .076.072 1 1 0 0 0 .135.13.7.7 0 0 0 .144.086.7.7 0 0 0 .163.046 1 1 0 0 0 .187.015 1 1 0 0 0 .146-.012.6.6 0 0 0 .128-.035.3.3 0 0 0 .09-.051.09.09 0 0 0 .035-.066c0-.094-.126-.2-.38-.308-.158-.067-.3-.131-.437-.192a3 3 0 0 1-.346-.18 1 1 0 0 1-.225-.183.3.3 0 0 1-.08-.206.28.28 0 0 1 .072-.176 1.5 1.5 0 0 1 .259-.224c.074-.046.08-.016.17-.048a1 1 0 0 1 .26-.058v-.114a.2.2 0 0 1-.008-.045.3.3 0 0 1 .008-.092",
    "data-name": "Path 14309"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.452 40.02a.12.12 0 0 1 .034-.065.2.2 0 0 1 .056-.041.3.3 0 0 1 .074-.023l.078-.014a.3.3 0 0 1 .089 0 .1.1 0 0 1 .05.023.06.06 0 0 1 .017.031v.042l-.005.026-.006.027-.028.231a2.4 2.4 0 0 1 .351.052 1.6 1.6 0 0 1 .291.094.7.7 0 0 1 .2.127.2.2 0 0 1 .072.147.13.13 0 0 1-.023.071.2.2 0 0 1-.062.058.3.3 0 0 1-.089.039.4.4 0 0 1-.1.014q-.078-.065-.15-.134a1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.092 1 1 0 0 0-.271-.037.6.6 0 0 0-.124.012.6.6 0 0 0-.116.033.3.3 0 0 0-.088.051.1.1 0 0 0-.034.067.23.23 0 0 0 .092.17 1.1 1.1 0 0 0 .286.172l.432.189a3 3 0 0 1 .342.169 1 1 0 0 1 .227.174.3.3 0 0 1 .081.206.3.3 0 0 1-.073.187.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.293.113 2 2 0 0 1-.354.058 1 1 0 0 1-.018.237.2.2 0 0 1-.22.146.1.1 0 0 1-.084-.038.2.2 0 0 1-.039-.095.5.5 0 0 1-.012-.125v-.128a1.2 1.2 0 0 1-.256-.055 1.5 1.5 0 0 1-.243-.1.8.8 0 0 1-.183-.124.18.18 0 0 1-.073-.128.12.12 0 0 1 .023-.07.2.2 0 0 1 .063-.061.3.3 0 0 1 .09-.044.4.4 0 0 1 .1-.015.1.1 0 0 1 .06.026.5.5 0 0 1 .075.072 1 1 0 0 0 .135.131.7.7 0 0 0 .144.085.7.7 0 0 0 .163.048 1 1 0 0 0 .189.014 1 1 0 0 0 .145-.011.7.7 0 0 0 .128-.034.3.3 0 0 0 .09-.052.09.09 0 0 0 .034-.065c0-.094-.125-.2-.38-.309-.157-.067-.3-.131-.438-.191a3 3 0 0 1-.344-.18 1 1 0 0 1-.225-.183.3.3 0 0 1-.079-.207.28.28 0 0 1 .07-.175.8.8 0 0 1 .183-.156 1.2 1.2 0 0 1 .246-.116 1 1 0 0 1 .261-.059v-.057q.001-.017-.005-.031v-.027l-.008-.046a.3.3 0 0 1 .008-.09",
    "data-name": "Path 14310"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M78.522 46.854a5.64 5.64 0 0 0-5.666-.037l-.827-.005-.007 1.559h.026c.206 1.036 1.745 1.848 3.621 1.86s3.427-.78 3.646-1.813h.026l.009-1.56Z",
    "data-name": "Path 14311"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M74.007 46.295a4 4 0 0 0-1.152.522l-.827-.005-.009 1.559h.026a2.55 2.55 0 0 0 1.938 1.616Z",
    "data-name": "Path 14312"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M75.41 46.077h-.1l-.026 4.137h.1Z",
    "data-name": "Path 14313"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m75.999 46.082-.119-.006-.027 4.154.119-.005Z",
    "data-name": "Path 14314"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m77.166 46.26-.138-.034-.025 3.869q.07-.015.139-.033Z",
    "data-name": "Path 14315"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.329 46.729c-.052-.031-.1-.061-.159-.089l-.019 3.053q.082-.042.158-.087Z",
    "data-name": "Path 14316"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.98 46.856h-.139l-.015 2.37a2 2 0 0 0 .139-.147Z",
    "data-name": "Path 14317"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m76.773 46.174-.1-.019-.026 4.007.1-.017Z",
    "data-name": "Path 14318"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M76.634 46.149a6 6 0 0 0-.434-.053l-.026 4.117q.222-.015.435-.047Z",
    "data-name": "Path 14319"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc200",
    d: "M79.348 47.03c-.007 1.149-1.653 2.07-3.674 2.057s-3.653-.955-3.646-2.1 1.653-2.07 3.673-2.057 3.654.954 3.647 2.1",
    "data-name": "Path 14320"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9198",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9197"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__w)",
    "data-name": "Group 9196",
    transform: "translate(74.158 45.06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.211 1.523a2.72 2.72 0 0 0 2.351-.6 5 5 0 0 0 .3-.382A4.46 4.46 0 0 0 1.543.003a6 6 0 0 0-1.5.167l-.02.067C-.13.82.323 1.39 1.205 1.526",
    "data-name": "Path 14321"
  }))))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.406 47.377a3.38 3.38 0 0 1-3.707.758 2.455 2.455 0 0 1-1.4-2.719 1.91 1.91 0 0 0-1.271 1.562c-.007 1.149 1.625 2.091 3.647 2.1s3.666-.908 3.674-2.057a1.34 1.34 0 0 0-.25-.764 4.6 4.6 0 0 1-.691 1.116",
    "data-name": "Path 14322"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9201",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9200"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__t)",
    "data-name": "Group 9199",
    transform: "translate(72.797 46.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.966C1.544 1.956.274 1.283.278.466A.86.86 0 0 1 .426.001 1.04 1.04 0 0 0 0 .775c0 .82 1.265 1.493 2.838 1.5a3.3 3.3 0 0 0 2.709-1 3.9 3.9 0 0 1-2.431.692",
    "data-name": "Path 14323"
  }))))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#f17800",
    d: "M75.436 45.609a.13.13 0 0 1 .033-.065 2 2 0 0 1 .177-.138c.022-.011-.073.079-.048.074s.053-.01.079-.013a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.1.1 0 0 1 .018.032v.041q.001.014-.005.027c-.006.013 0 .017-.006.027l-.027.231a2.4 2.4 0 0 1 .351.052 1.6 1.6 0 0 1 .291.094.7.7 0 0 1 .2.126.2.2 0 0 1 .073.148c0 .025.091-.025.076 0a1 1 0 0 1-.16.133.4.4 0 0 1-.09.04.4.4 0 0 1-.1.013 4 4 0 0 1-.149-.134 1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.093 1 1 0 0 0-.271-.037.7.7 0 0 0-.123.013 1 1 0 0 0-.116.033.3.3 0 0 0-.088.051.1.1 0 0 0-.035.067.24.24 0 0 0 .094.169 1.1 1.1 0 0 0 .286.171q.234.1.432.188a4 4 0 0 1 .343.17 1 1 0 0 1 .226.174.3.3 0 0 1 .081.207.3.3 0 0 1-.073.187.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.292.114 2 2 0 0 1-.356.058c0 .126.1.13.095.161a.33.33 0 0 1-.333.222.1.1 0 0 1-.083-.038.2.2 0 0 1-.04-.1.6.6 0 0 1-.011-.125v-.129a1 1 0 0 1-.255-.054 1.5 1.5 0 0 1-.244-.1 1 1 0 0 1-.183-.124.18.18 0 0 1-.073-.128.12.12 0 0 1 .025-.07 2 2 0 0 1 .208-.174c.027-.018-.038.128-.005.118s.016-.063.051-.062a.1.1 0 0 1 .06.025.6.6 0 0 1 .075.072 1 1 0 0 0 .135.131.7.7 0 0 0 .144.086.8.8 0 0 0 .164.047 1.3 1.3 0 0 0 .188.014 1 1 0 0 0 .145-.012 1 1 0 0 0 .128-.034.3.3 0 0 0 .09-.052.09.09 0 0 0 .034-.066q0-.14-.378-.308-.237-.1-.438-.191a3 3 0 0 1-.346-.18.9.9 0 0 1-.224-.183.3.3 0 0 1-.081-.205.3.3 0 0 1 .072-.176 1.5 1.5 0 0 1 .258-.225c.075-.047.08-.016.17-.047a1 1 0 0 1 .261-.058v-.113l-.008-.046a.3.3 0 0 1 .009-.09",
    "data-name": "Path 14324"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc800",
    d: "M75.555 45.512a.12.12 0 0 1 .033-.065.2.2 0 0 1 .058-.04.3.3 0 0 1 .072-.025q.039-.008.079-.013a.3.3 0 0 1 .089 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .019.031v.042q.001.015-.005.027c-.006.012 0 .017-.005.028l-.028.23a2 2 0 0 1 .351.051 1.5 1.5 0 0 1 .292.095.7.7 0 0 1 .2.126.2.2 0 0 1 .073.147.12.12 0 0 1-.023.071.2.2 0 0 1-.061.059.37.37 0 0 1-.194.052q-.077-.065-.149-.133a1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.093 1 1 0 0 0-.271-.036.6.6 0 0 0-.123.012 1 1 0 0 0-.117.033.3.3 0 0 0-.087.052.09.09 0 0 0-.035.066.23.23 0 0 0 .093.169 1 1 0 0 0 .286.171q.234.104.433.189a4 4 0 0 1 .343.169 1 1 0 0 1 .226.174.3.3 0 0 1 .081.207.3.3 0 0 1-.073.188.7.7 0 0 1-.2.157 1.3 1.3 0 0 1-.292.114 2 2 0 0 1-.356.058 1 1 0 0 1-.018.237.2.2 0 0 1-.22.147.1.1 0 0 1-.084-.038.2.2 0 0 1-.039-.1.6.6 0 0 1-.012-.125v-.127a1.2 1.2 0 0 1-.256-.055 1.6 1.6 0 0 1-.244-.1 1 1 0 0 1-.183-.124.18.18 0 0 1-.072-.129.13.13 0 0 1 .024-.069.3.3 0 0 1 .063-.061.3.3 0 0 1 .09-.043.3.3 0 0 1 .1-.015.1.1 0 0 1 .061.026.5.5 0 0 1 .075.073 1 1 0 0 0 .135.13.7.7 0 0 0 .144.086.7.7 0 0 0 .163.046 1 1 0 0 0 .188.015 1 1 0 0 0 .145-.011.7.7 0 0 0 .129-.035.3.3 0 0 0 .091-.051.09.09 0 0 0 .035-.066c0-.093-.127-.2-.38-.308-.158-.067-.3-.131-.437-.191a3 3 0 0 1-.345-.18 1 1 0 0 1-.225-.183.3.3 0 0 1-.08-.206.27.27 0 0 1 .072-.175.7.7 0 0 1 .182-.156 1.3 1.3 0 0 1 .246-.117 1.1 1.1 0 0 1 .261-.058v-.114q.002-.008-.007-.047a.2.2 0 0 1 .008-.091",
    "data-name": "Path 14325"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M78.531 45.366a5.64 5.64 0 0 0-5.666-.036h-.827l-.011 1.56h.027c.2 1.035 1.746 1.848 3.621 1.86s3.426-.78 3.646-1.814h.025l.01-1.56Z",
    "data-name": "Path 14326"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M74.016 44.807a4 4 0 0 0-1.151.523l-.827-.005-.01 1.56h.027a2.55 2.55 0 0 0 1.938 1.615Z",
    "data-name": "Path 14327"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M75.42 44.593h-.1l-.027 4.137.1.005Z",
    "data-name": "Path 14328"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M76.012 44.596h-.118l-.027 4.153h.119Z",
    "data-name": "Path 14329"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M77.177 44.773q-.069-.019-.139-.034l-.025 3.87q.07-.016.138-.033Z",
    "data-name": "Path 14330"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.338 45.243c-.052-.031-.1-.061-.158-.089l-.02 3.053a3 3 0 0 0 .159-.088Z",
    "data-name": "Path 14331"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.992 45.37h-.139l-.015 2.37c.05-.048.1-.1.139-.146Z",
    "data-name": "Path 14332"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m76.784 44.687-.1-.019-.026 4.007.1-.017Z",
    "data-name": "Path 14333"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M76.645 44.662a6 6 0 0 0-.436-.053l-.025 4.118q.221-.017.435-.047Z",
    "data-name": "Path 14334"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc200",
    d: "M79.358 45.543c-.007 1.149-1.652 2.069-3.673 2.056s-3.653-.954-3.645-2.1 1.651-2.069 3.672-2.057 3.654.955 3.647 2.1",
    "data-name": "Path 14335"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9204",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9203"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__v)",
    "data-name": "Group 9202",
    transform: "translate(74.168 43.574)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.211 1.524a2.72 2.72 0 0 0 2.351-.6 4 4 0 0 0 .3-.381A4.46 4.46 0 0 0 1.544.005a6 6 0 0 0-1.5.167l-.02.066c-.154.583.3 1.152 1.182 1.29",
    "data-name": "Path 14336"
  }))))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.415 45.894a3.39 3.39 0 0 1-3.708.759 2.456 2.456 0 0 1-1.4-2.719 1.91 1.91 0 0 0-1.27 1.562c-.008 1.149 1.624 2.09 3.646 2.1s3.666-.907 3.673-2.056a1.33 1.33 0 0 0-.25-.764 4.5 4.5 0 0 1-.691 1.115",
    "data-name": "Path 14337"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9207",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9206"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__t)",
    "data-name": "Group 9205",
    transform: "translate(72.807 44.569)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.969C1.544 1.959.274 1.287.278.469A.87.87 0 0 1 .426.003 1.04 1.04 0 0 0 0 .778c-.005.82 1.266 1.493 2.838 1.5a3.3 3.3 0 0 0 2.71-1 3.9 3.9 0 0 1-2.431.692",
    "data-name": "Path 14338"
  }))))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#f17800",
    d: "M75.446 44.122a.13.13 0 0 1 .033-.064 2 2 0 0 1 .177-.139c.022-.011-.073.079-.047.074a1 1 0 0 1 .078-.013.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .019.032v.04l-.005.028-.006.027-.027.23a2.4 2.4 0 0 1 .351.052 1.5 1.5 0 0 1 .29.095.7.7 0 0 1 .2.126.2.2 0 0 1 .073.147c0 .025.091-.026.077 0a1.3 1.3 0 0 1-.161.133.4.4 0 0 1-.089.039.4.4 0 0 1-.105.014l-.149-.134a1 1 0 0 0-.158-.124.8.8 0 0 0-.2-.093 1 1 0 0 0-.271-.037.6.6 0 0 0-.123.012 1 1 0 0 0-.116.033.3.3 0 0 0-.088.053.09.09 0 0 0-.035.066.24.24 0 0 0 .092.171 1.1 1.1 0 0 0 .286.17l.433.189a3 3 0 0 1 .342.168 1 1 0 0 1 .226.175.3.3 0 0 1 .081.206.3.3 0 0 1-.073.187.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.292.114 2 2 0 0 1-.356.058c0 .125.1.129.093.161a.33.33 0 0 1-.33.223.1.1 0 0 1-.084-.038.2.2 0 0 1-.04-.1.6.6 0 0 1-.011-.125v-.128a1.2 1.2 0 0 1-.256-.054 2 2 0 0 1-.243-.1 1 1 0 0 1-.184-.125.18.18 0 0 1-.073-.127.14.14 0 0 1 .025-.072 3 3 0 0 1 .208-.174c.027-.018-.038.128-.005.118s.016-.063.05-.062a.1.1 0 0 1 .061.026.5.5 0 0 1 .075.071 1 1 0 0 0 .135.131.7.7 0 0 0 .145.086.7.7 0 0 0 .162.046 1 1 0 0 0 .188.015 1 1 0 0 0 .146-.012.6.6 0 0 0 .128-.034.3.3 0 0 0 .09-.051.1.1 0 0 0 .035-.066c0-.094-.127-.2-.38-.308l-.437-.191a3 3 0 0 1-.346-.18 1 1 0 0 1-.224-.183.3.3 0 0 1-.08-.206.28.28 0 0 1 .072-.176 1.5 1.5 0 0 1 .259-.226c.074-.046.08-.015.17-.047a1.2 1.2 0 0 1 .26-.059v-.114a.2.2 0 0 1-.007-.046.2.2 0 0 1 .008-.092",
    "data-name": "Path 14339"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc800",
    d: "M75.565 44.025a.12.12 0 0 1 .033-.065.2.2 0 0 1 .057-.041.3.3 0 0 1 .072-.023q.039-.008.078-.013a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .018.031v.069q.001.012-.006.028l-.027.23a2 2 0 0 1 .351.051 1.5 1.5 0 0 1 .291.095.7.7 0 0 1 .2.126.2.2 0 0 1 .072.147.12.12 0 0 1-.023.071.2.2 0 0 1-.062.058.3.3 0 0 1-.089.039.4.4 0 0 1-.106.014 4 4 0 0 1-.148-.134 1 1 0 0 0-.157-.124.9.9 0 0 0-.2-.093 1 1 0 0 0-.272-.037.7.7 0 0 0-.123.012 1 1 0 0 0-.117.033.3.3 0 0 0-.088.052.1.1 0 0 0-.035.067.24.24 0 0 0 .094.17 1.1 1.1 0 0 0 .286.172q.234.103.432.188a3 3 0 0 1 .343.169 1 1 0 0 1 .226.174.29.29 0 0 1 .009.393.7.7 0 0 1-.2.157 1.3 1.3 0 0 1-.292.114 2 2 0 0 1-.356.058 1 1 0 0 1-.017.237.2.2 0 0 1-.22.147.1.1 0 0 1-.084-.039.24.24 0 0 1-.04-.094.7.7 0 0 1-.011-.126v-.128a1.2 1.2 0 0 1-.256-.054 1.5 1.5 0 0 1-.243-.1.8.8 0 0 1-.183-.124.18.18 0 0 1-.073-.127.13.13 0 0 1 .024-.071.3.3 0 0 1 .064-.061.4.4 0 0 1 .089-.042.3.3 0 0 1 .1-.015.1.1 0 0 1 .06.026.5.5 0 0 1 .076.072 1 1 0 0 0 .135.13.7.7 0 0 0 .144.086.7.7 0 0 0 .164.047 1 1 0 0 0 .187.015 1 1 0 0 0 .145-.012.6.6 0 0 0 .128-.034.4.4 0 0 0 .091-.052.1.1 0 0 0 .035-.065c0-.094-.127-.2-.38-.309q-.237-.1-.437-.19a3 3 0 0 1-.346-.18 1 1 0 0 1-.224-.184.3.3 0 0 1-.08-.205.27.27 0 0 1 .071-.176.7.7 0 0 1 .183-.156 1.2 1.2 0 0 1 .247-.117 1.2 1.2 0 0 1 .26-.059v-.113a.3.3 0 0 1-.008-.047.2.2 0 0 1 .008-.09",
    "data-name": "Path 14340"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M78.541 43.896a5.63 5.63 0 0 0-5.667-.036l-.825-.006-.01 1.56h.026c.2 1.035 1.745 1.847 3.621 1.86s3.426-.781 3.646-1.813h.026l.01-1.56Z",
    "data-name": "Path 14341"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M74.027 43.337a4 4 0 0 0-1.152.523l-.826-.006-.01 1.56h.026a2.55 2.55 0 0 0 1.938 1.615Z",
    "data-name": "Path 14342"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M75.429 43.119h-.1l-.027 4.137.1.005Z",
    "data-name": "Path 14343"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m76.022 43.124-.118-.006-.027 4.154h.118Z",
    "data-name": "Path 14344"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m77.187 43.303-.138-.035-.026 3.871.138-.034Z",
    "data-name": "Path 14345"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.35 43.776c-.052-.031-.1-.061-.158-.089l-.02 3.054q.082-.043.159-.088Z",
    "data-name": "Path 14346"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.998 43.899h-.135l-.016 2.37a2 2 0 0 0 .14-.146Z",
    "data-name": "Path 14347"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m76.791 43.219-.1-.018-.026 4.005.1-.016Z",
    "data-name": "Path 14348"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M76.653 43.191a7 7 0 0 0-.434-.053l-.027 4.119q.223-.017.434-.048Z",
    "data-name": "Path 14349"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc200",
    d: "M79.366 44.072c-.007 1.148-1.652 2.07-3.673 2.057s-3.654-.954-3.645-2.1 1.651-2.069 3.672-2.057 3.654.954 3.647 2.1",
    "data-name": "Path 14350"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9210",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9209"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__w)",
    "data-name": "Group 9208",
    transform: "translate(74.177 42.103)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.211 1.523a2.71 2.71 0 0 0 2.351-.6 5 5 0 0 0 .3-.381A4.46 4.46 0 0 0 1.543.004a6 6 0 0 0-1.5.168l-.02.066c-.153.583.3 1.154 1.182 1.29",
    "data-name": "Path 14351"
  }))))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.413 44.577a3.39 3.39 0 0 1-3.708.758 2.456 2.456 0 0 1-1.4-2.72 1.91 1.91 0 0 0-1.27 1.562c-.008 1.149 1.624 2.09 3.645 2.1s3.666-.908 3.673-2.057a1.32 1.32 0 0 0-.25-.763 4.6 4.6 0 0 1-.69 1.115",
    "data-name": "Path 14352"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9213",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9212"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__x)",
    "data-name": "Group 9211",
    transform: "translate(72.816 43.098)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.97C1.544 1.96.273 1.287.279.47A.87.87 0 0 1 .427.003a1.04 1.04 0 0 0-.426.775c-.006.82 1.265 1.493 2.838 1.5a3.3 3.3 0 0 0 2.71-1 3.9 3.9 0 0 1-2.431.693",
    "data-name": "Path 14353"
  }))))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#f17800",
    d: "M75.455 42.652a.13.13 0 0 1 .033-.065c.017-.017.156-.129.177-.139s-.073.08-.047.074.052-.01.078-.013a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .019.032v.041l-.006.027v.028l-.028.23a2.3 2.3 0 0 1 .352.052 1.6 1.6 0 0 1 .291.094.7.7 0 0 1 .2.127.2.2 0 0 1 .073.147c0 .025.091-.025.077 0a1.3 1.3 0 0 1-.161.132.3.3 0 0 1-.09.04.3.3 0 0 1-.1.013q-.077-.065-.149-.132a1 1 0 0 0-.157-.125 1 1 0 0 0-.2-.093 1 1 0 0 0-.272-.036.6.6 0 0 0-.123.012 1 1 0 0 0-.117.034.3.3 0 0 0-.087.052.09.09 0 0 0-.035.066.23.23 0 0 0 .093.17 1.1 1.1 0 0 0 .286.172q.235.1.433.189a3 3 0 0 1 .342.168 1 1 0 0 1 .227.175.29.29 0 0 1 .007.393.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.292.113 2 2 0 0 1-.356.058c0 .126.1.13.094.162a.33.33 0 0 1-.332.222.1.1 0 0 1-.083-.038.23.23 0 0 1-.04-.095.6.6 0 0 1-.011-.125v-.128a1.3 1.3 0 0 1-.255-.055 1.6 1.6 0 0 1-.244-.1 1 1 0 0 1-.184-.124.18.18 0 0 1-.072-.128.12.12 0 0 1 .025-.07 2 2 0 0 1 .209-.175c.026-.018-.039.128-.007.117s.017-.062.052-.062a.1.1 0 0 1 .06.027.4.4 0 0 1 .076.072 1 1 0 0 0 .134.131.7.7 0 0 0 .145.085.7.7 0 0 0 .163.047 1 1 0 0 0 .188.014 1 1 0 0 0 .144-.011.6.6 0 0 0 .129-.034.3.3 0 0 0 .09-.051.08.08 0 0 0 .034-.065q0-.14-.378-.309c-.159-.067-.3-.131-.438-.191a3 3 0 0 1-.346-.179 1 1 0 0 1-.224-.183.3.3 0 0 1-.08-.206.28.28 0 0 1 .072-.176 1.5 1.5 0 0 1 .259-.225c.076-.046.081-.015.17-.047a1 1 0 0 1 .26-.058v-.114q.002-.008-.007-.047a.2.2 0 0 1 .008-.09",
    "data-name": "Path 14354"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc800",
    d: "M75.574 42.554a.14.14 0 0 1 .034-.064.2.2 0 0 1 .057-.041.3.3 0 0 1 .072-.023 1 1 0 0 1 .079-.013.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.05.05 0 0 1 .018.032v.068q.002.013-.006.027l-.027.23a2.3 2.3 0 0 1 .351.052 1.6 1.6 0 0 1 .291.094.7.7 0 0 1 .2.127.2.2 0 0 1 .073.148.12.12 0 0 1-.023.071.2.2 0 0 1-.061.058.3.3 0 0 1-.089.039.4.4 0 0 1-.1.013q-.077-.064-.15-.132a1 1 0 0 0-.157-.124.8.8 0 0 0-.2-.092.9.9 0 0 0-.272-.037.6.6 0 0 0-.123.012 1 1 0 0 0-.116.033.3.3 0 0 0-.088.052.1.1 0 0 0-.035.066.24.24 0 0 0 .093.17 1.1 1.1 0 0 0 .286.172l.432.189a3 3 0 0 1 .342.169.9.9 0 0 1 .226.174.286.286 0 0 1 .008.393.6.6 0 0 1-.2.158 1.3 1.3 0 0 1-.292.113 2 2 0 0 1-.356.058 1 1 0 0 1-.018.237.2.2 0 0 1-.22.147.1.1 0 0 1-.084-.039.2.2 0 0 1-.039-.095.6.6 0 0 1-.011-.125v-.128a1.3 1.3 0 0 1-.256-.054 2 2 0 0 1-.244-.1 1 1 0 0 1-.183-.125.18.18 0 0 1-.073-.127.13.13 0 0 1 .024-.071.3.3 0 0 1 .064-.06.3.3 0 0 1 .088-.043.3.3 0 0 1 .1-.015.1.1 0 0 1 .06.025.5.5 0 0 1 .075.072 1 1 0 0 0 .135.13.6.6 0 0 0 .145.087.7.7 0 0 0 .163.047 1.4 1.4 0 0 0 .189.015 1 1 0 0 0 .145-.012.6.6 0 0 0 .128-.035.3.3 0 0 0 .09-.051.09.09 0 0 0 .035-.066c0-.093-.126-.2-.379-.308-.159-.068-.3-.131-.438-.191a3 3 0 0 1-.345-.18 1 1 0 0 1-.225-.182.3.3 0 0 1-.08-.207.27.27 0 0 1 .071-.175.7.7 0 0 1 .182-.156 1.2 1.2 0 0 1 .247-.117 1 1 0 0 1 .261-.059v-.114l-.007-.046a.2.2 0 0 1 .008-.091",
    "data-name": "Path 14355"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M78.55 42.409a5.64 5.64 0 0 0-5.666-.036l-.827-.005-.01 1.56h.026c.206 1.035 1.745 1.848 3.622 1.861s3.426-.781 3.645-1.813h.026l.01-1.56Z",
    "data-name": "Path 14356"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#d03c3e",
    d: "M74.036 41.851a4 4 0 0 0-1.151.522l-.827-.005-.01 1.56h.026a2.55 2.55 0 0 0 1.938 1.615Z",
    "data-name": "Path 14357"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M75.443 41.629h-.1l-.026 4.136h.1Z",
    "data-name": "Path 14358"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m76.031 41.638-.119-.006-.027 4.154h.119Z",
    "data-name": "Path 14359"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M77.195 41.816q-.068-.019-.138-.034l-.025 3.87.138-.033Z",
    "data-name": "Path 14360"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M78.357 42.285c-.052-.031-.1-.061-.158-.089l-.019 3.053q.082-.043.158-.087Z",
    "data-name": "Path 14361"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M79.007 42.412h-.138l-.016 2.37c.051-.047.1-.1.14-.145Z",
    "data-name": "Path 14362"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m76.801 41.729-.1-.019-.026 4.007.1-.016Z",
    "data-name": "Path 14363"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M76.663 41.704a5 5 0 0 0-.433-.053l-.026 4.119q.222-.016.434-.047Z",
    "data-name": "Path 14364"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M79.375 42.586c-.007 1.149-1.651 2.069-3.673 2.056s-3.653-.954-3.646-2.1 1.652-2.069 3.673-2.056 3.654.955 3.646 2.1",
    "data-name": "Path 14365"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9216",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9215"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__w)",
    "data-name": "Group 9214",
    transform: "translate(74.187 40.617)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.211 1.523a2.72 2.72 0 0 0 2.352-.6 5 5 0 0 0 .3-.38 4.44 4.44 0 0 0-2.318-.54 6 6 0 0 0-1.5.168l-.02.066c-.153.583.3 1.153 1.182 1.289",
    "data-name": "Path 14366"
  }))))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#d54a4b",
    d: "M78.434 42.938a3.385 3.385 0 0 1-3.708.759 2.46 2.46 0 0 1-1.4-2.72 1.91 1.91 0 0 0-1.271 1.562c-.007 1.149 1.626 2.09 3.647 2.1s3.666-.907 3.673-2.056a1.32 1.32 0 0 0-.249-.764 4.6 4.6 0 0 1-.691 1.115",
    "data-name": "Path 14367"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9219",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9218"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__t)",
    "data-name": "Group 9217",
    transform: "translate(72.826 41.611)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.116 1.97C1.544 1.96.273 1.287.279.47A.9.9 0 0 1 .426.004a1.04 1.04 0 0 0-.425.775c-.006.82 1.265 1.493 2.838 1.5a3.3 3.3 0 0 0 2.709-1 3.9 3.9 0 0 1-2.431.693",
    "data-name": "Path 14368"
  }))))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M75.465 41.166a.12.12 0 0 1 .033-.065 2 2 0 0 1 .176-.139c.022-.01-.073.079-.046.074a1 1 0 0 1 .078-.013.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.023.06.06 0 0 1 .018.032v.041l-.005.027-.005.027-.028.231a2 2 0 0 1 .351.051 1.6 1.6 0 0 1 .291.094.8.8 0 0 1 .2.127.2.2 0 0 1 .071.148c0 .024.092-.025.077 0a1 1 0 0 1-.161.132.3.3 0 0 1-.089.039.4.4 0 0 1-.1.014q-.076-.065-.15-.133a1 1 0 0 0-.158-.125.8.8 0 0 0-.2-.092.9.9 0 0 0-.271-.037 1 1 0 0 0-.123.012.6.6 0 0 0-.116.033.3.3 0 0 0-.088.052.09.09 0 0 0-.035.066.24.24 0 0 0 .094.17 1.1 1.1 0 0 0 .286.172q.235.104.432.188a3 3 0 0 1 .342.169 1 1 0 0 1 .227.174.29.29 0 0 1 .008.394.7.7 0 0 1-.2.157 1.3 1.3 0 0 1-.292.113 2 2 0 0 1-.355.058c0 .126.1.129.094.162a.33.33 0 0 1-.332.222.1.1 0 0 1-.084-.038.24.24 0 0 1-.039-.1.6.6 0 0 1-.012-.125v-.128a1.2 1.2 0 0 1-.255-.055 1.6 1.6 0 0 1-.245-.1 1 1 0 0 1-.183-.124.18.18 0 0 1-.072-.128.12.12 0 0 1 .025-.07 2 2 0 0 1 .208-.175c.025-.018-.039.128-.006.118s.017-.063.051-.063a.1.1 0 0 1 .061.027.5.5 0 0 1 .075.072 1 1 0 0 0 .135.13.7.7 0 0 0 .144.085.7.7 0 0 0 .164.047 1 1 0 0 0 .187.015 1 1 0 0 0 .145-.012 1 1 0 0 0 .128-.034.3.3 0 0 0 .09-.052.09.09 0 0 0 .034-.065c0-.094-.126-.2-.379-.309-.158-.067-.3-.13-.438-.191a3 3 0 0 1-.345-.18 1 1 0 0 1-.225-.183.3.3 0 0 1-.079-.206.28.28 0 0 1 .071-.176 1.6 1.6 0 0 1 .259-.225c.074-.046.08-.015.17-.046a1 1 0 0 1 .26-.059V41.3a.2.2 0 0 1-.008-.046.3.3 0 0 1 .009-.09",
    "data-name": "Path 14369"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.584 41.069a.12.12 0 0 1 .033-.065.2.2 0 0 1 .058-.042.3.3 0 0 1 .074-.023q.038-.009.078-.014a.3.3 0 0 1 .09 0 .1.1 0 0 1 .048.024.06.06 0 0 1 .019.031v.042l-.005.027-.005.028-.028.229a2.4 2.4 0 0 1 .352.052 1.6 1.6 0 0 1 .291.095.7.7 0 0 1 .2.127.2.2 0 0 1 .073.147.13.13 0 0 1-.023.071.2.2 0 0 1-.062.058.4.4 0 0 1-.089.039.4.4 0 0 1-.1.013 5 5 0 0 1-.149-.133 1 1 0 0 0-.157-.124.8.8 0 0 0-.2-.093 1 1 0 0 0-.272-.037.7.7 0 0 0-.123.012.6.6 0 0 0-.117.033.3.3 0 0 0-.088.051.1.1 0 0 0-.034.067.23.23 0 0 0 .093.17 1.1 1.1 0 0 0 .286.171l.432.189a3 3 0 0 1 .343.169 1 1 0 0 1 .227.174.3.3 0 0 1 .081.206.3.3 0 0 1-.073.187.7.7 0 0 1-.2.158 1.3 1.3 0 0 1-.292.113 2 2 0 0 1-.356.058 1 1 0 0 1-.018.238.2.2 0 0 1-.22.146.1.1 0 0 1-.084-.039.2.2 0 0 1-.04-.095.6.6 0 0 1-.011-.125v-.129a1 1 0 0 1-.256-.054 1.5 1.5 0 0 1-.244-.1.8.8 0 0 1-.183-.125.18.18 0 0 1-.073-.128.12.12 0 0 1 .024-.069.3.3 0 0 1 .064-.061.3.3 0 0 1 .089-.043.3.3 0 0 1 .1-.015.1.1 0 0 1 .059.026.5.5 0 0 1 .075.071 1 1 0 0 0 .136.131.6.6 0 0 0 .144.086.7.7 0 0 0 .163.047 1.4 1.4 0 0 0 .188.015 1 1 0 0 0 .145-.011.6.6 0 0 0 .129-.035.3.3 0 0 0 .09-.051.1.1 0 0 0 .035-.066q0-.141-.379-.309c-.158-.067-.3-.131-.438-.191a3 3 0 0 1-.345-.179 1 1 0 0 1-.224-.183.3.3 0 0 1-.08-.207.28.28 0 0 1 .071-.175.7.7 0 0 1 .183-.156 1.2 1.2 0 0 1 .247-.117 1 1 0 0 1 .26-.059v-.114l-.007-.046a.2.2 0 0 1 .008-.09",
    "data-name": "Path 14370"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#bababa",
    d: "M29.312 52.846a.367.367 0 0 1 .478.194l.791 2.276a.391.391 0 0 1-.732.255l-.791-2.276a.366.366 0 0 1 .254-.448",
    "data-name": "Path 14372"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#bababa",
    d: "M30.573 56.48a.366.366 0 0 1 .478.194l.791 2.275a.391.391 0 0 1-.733.255l-.791-2.275a.366.366 0 0 1 .255-.448",
    "data-name": "Path 14373"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#bababa",
    d: "M32.157 61.029c.2-.07.4-.039.435.07l.486 1.4c.038.109-.1.254-.3.324s-.4.039-.435-.07l-.486-1.4c-.037-.109.1-.254.3-.324",
    "data-name": "Path 14374"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "M36.43 73.315a1.207 1.207 0 0 1-.744 1.536l-9.942 3.457a1.207 1.207 0 0 1-1.536-.743l-7.53-21.656a1.207 1.207 0 0 1 .743-1.536l9.942-3.457a1.207 1.207 0 0 1 1.536.743Z",
    "data-name": "Path 14375"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#212120",
    d: "M35.955 73.095a1.153 1.153 0 0 1-.689 1.477l-9.363 3.256a1.153 1.153 0 0 1-1.457-.73l-7.292-20.969a1.153 1.153 0 0 1 .69-1.477l9.363-3.256a1.153 1.153 0 0 1 1.457.73Z",
    "data-name": "Path 14376"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#141413",
    d: "m17.901 57.081 10.685-3.716 6.11 17.572-10.684 3.716z",
    "data-name": "Rectangle 581"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.217 57.197 10.194-3.545 5.97 17.17-10.194 3.544z",
    "data-name": "Rectangle 582"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e3e3",
    d: "m34.382 70.818-10.195 3.547-5.97-17.168Z",
    "data-name": "Path 14377"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#141413",
    d: "M23.733 53.642a.277.277 0 0 1-.17.352l-1.852.644a.276.276 0 0 1-.182-.522l1.852-.644a.277.277 0 0 1 .352.17",
    "data-name": "Path 14378"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#141413",
    d: "M24.981 53.26a.327.327 0 1 1-.416-.2.326.326 0 0 1 .416.2",
    "data-name": "Path 14379"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#141413",
    d: "M31.231 73.906a1.364 1.364 0 1 1-1.736-.84 1.364 1.364 0 0 1 1.736.84",
    "data-name": "Path 14380"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8b8b",
    d: "m35.801 76.441.7.635a1.074 1.074 0 0 0 1.518-.062l31.144-34.395a1.074 1.074 0 0 0-.089-1.516l-.7-.635Z",
    "data-name": "Path 14381"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "m35.801 76.441-3.515-10.683 25.109-27.731 10.979 2.441Z",
    "data-name": "Path 14382"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b1b1b0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "m63.533 40.703-5.844-1.3-24.007 26.51 1.871 5.687Z",
    "data-name": "Path 14383"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a5a5",
    d: "m55.981 53.043-2.163-.691-7.629 8.426.9 2.084Z",
    "data-name": "Path 14384"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8b8b",
    d: "M57.2 37.076a1.174 1.174 0 0 1 .082 1.659l-24.3 26.841a1.175 1.175 0 0 1-1.659.082L16.354 52.107a1.174 1.174 0 0 1-.082-1.659l24.3-26.841a1.174 1.174 0 0 1 1.658-.082Z",
    "data-name": "Path 14385"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#25364f",
    d: "M56.55 37.262a1.14 1.14 0 0 1 .08 1.61L33.05 64.913a1.14 1.14 0 0 1-1.61.08L17.005 51.919a1.14 1.14 0 0 1-.08-1.609l23.58-26.042a1.14 1.14 0 0 1 1.609-.08Z",
    "data-name": "Path 14386"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    d: "m18.34 51.046 23.037-25.442 13.74 12.44L32.08 63.488z",
    "data-name": "Rectangle 583"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.036 50.862 22.226-24.545L54.419 38.23 32.193 62.776z",
    "data-name": "Rectangle 584"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#bababa",
    d: "M29.565 37.451a.452.452 0 1 1-.638.032.45.45 0 0 1 .638-.032",
    "data-name": "Path 14387"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "M36.018 63.985 34.647 65.5l-.1-.3 1.359-1.5.111.287",
    "data-name": "Path 14388"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m37.959 61.841-1.371 1.515-.117-.281 1.359-1.5.129.267",
    "data-name": "Path 14389"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m39.901 59.697-1.372 1.515-.134-.261 1.359-1.5z",
    "data-name": "Path 14390"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m41.842 57.553-1.371 1.515-.153-.241 1.359-1.5z",
    "data-name": "Path 14391"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m43.783 55.409-1.371 1.515-.171-.221 1.359-1.5.183.208",
    "data-name": "Path 14392"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m45.725 53.264-1.372 1.515-.188-.2 1.359-1.5.2.187",
    "data-name": "Path 14393"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m47.666 51.121-1.371 1.515-.206-.182 1.359-1.5.219.168",
    "data-name": "Path 14394"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m49.607 48.977-1.372 1.515-.224-.162 1.359-1.5.237.148",
    "data-name": "Path 14395"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m51.549 46.833-1.372 1.514-.243-.142 1.359-1.5z",
    "data-name": "Path 14396"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m53.49 44.689-1.371 1.515-.26-.122 1.359-1.5.273.108",
    "data-name": "Path 14397"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "M55.432 42.545 54.06 44.06l-.278-.1 1.359-1.5.291.088",
    "data-name": "Path 14398"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m57.372 40.402-1.371 1.514-.3-.082 1.359-1.5.308.069",
    "data-name": "Path 14399"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m36.383 64.921-1.413 1.56-.223-.676 1.384-1.529.251.645",
    "data-name": "Path 14400"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m38.383 62.712-1.413 1.56-.263-.632 1.385-1.529z",
    "data-name": "Path 14401"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m40.382 60.503-1.413 1.561-.3-.587 1.384-1.529.332.555",
    "data-name": "Path 14402"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m42.383 58.295-1.413 1.561-.344-.542 1.385-1.529z",
    "data-name": "Path 14403"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m44.382 56.086-1.413 1.561-.384-.5 1.385-1.529.412.466",
    "data-name": "Path 14404"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m46.382 53.878-1.413 1.56-.424-.453 1.385-1.529z",
    "data-name": "Path 14405"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m48.383 51.669-1.413 1.56-.465-.409 1.384-1.529.493.377",
    "data-name": "Path 14406"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m50.382 49.46-1.413 1.56-.5-.364 1.384-1.529.534.333",
    "data-name": "Path 14407"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m52.382 47.251-1.413 1.561-.546-.32 1.385-1.529z",
    "data-name": "Path 14408"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m54.382 45.042-1.413 1.561-.585-.275 1.384-1.529z",
    "data-name": "Path 14409"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m56.382 42.834-1.413 1.56-.626-.23 1.385-1.529.655.2",
    "data-name": "Path 14410"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m58.381 40.626-1.413 1.56-.667-.186 1.384-1.529z",
    "data-name": "Path 14411"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m37.74 64.768-2.444 2.7-.222-.676 2.4-2.647.27.623",
    "data-name": "Path 14412"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m39.774 62.523-1.455 1.606-.282-.611 1.426-1.574z",
    "data-name": "Path 14413"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m41.832 60.249-1.455 1.606-.322-.566 1.426-1.575z",
    "data-name": "Path 14414"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m43.891 57.975-1.455 1.607-.362-.522 1.426-1.575z",
    "data-name": "Path 14415"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m45.949 55.705-1.454 1.606-.4-.477 1.426-1.575.431.446",
    "data-name": "Path 14416"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m48.009 53.427-1.455 1.607-.443-.433 1.426-1.575.472.4",
    "data-name": "Path 14417"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m50.067 51.154-1.455 1.607-.483-.388 1.426-1.575z",
    "data-name": "Path 14418"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m52.127 48.88-1.455 1.607-.524-.343 1.426-1.575.552.312",
    "data-name": "Path 14419"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m54.189 46.606-1.455 1.607-.564-.3 1.426-1.575.593.267",
    "data-name": "Path 14420"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m56.24 44.333-1.455 1.607-.6-.254 1.427-1.575.633.223",
    "data-name": "Path 14421"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m59.396 40.852-2.57 2.838-.645-.21 2.519-2.782.695.155",
    "data-name": "Path 14422"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m37.116 66.804-1.5 1.652-.223-.676 1.468-1.621.251.645",
    "data-name": "Path 14423"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m39.233 64.464-1.5 1.653-.263-.632 1.468-1.621.291.6",
    "data-name": "Path 14424"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m41.352 62.126-1.5 1.653-.3-.587 1.468-1.621z",
    "data-name": "Path 14425"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m43.469 59.787-1.5 1.653-.343-.543 1.468-1.621.372.511",
    "data-name": "Path 14426"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m45.586 57.448-1.5 1.653-.384-.5 1.468-1.621.412.466",
    "data-name": "Path 14427"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m47.705 55.109-1.5 1.652-.425-.453 1.468-1.621.453.422",
    "data-name": "Path 14428"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m49.823 52.77-1.5 1.653-.465-.409 1.467-1.621.493.377",
    "data-name": "Path 14429"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m51.941 50.432-1.5 1.653-.505-.364 1.468-1.621.534.333",
    "data-name": "Path 14430"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m54.058 48.089-1.5 1.653-.546-.32 1.468-1.621.574.289",
    "data-name": "Path 14431"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m56.175 45.755-1.5 1.653-.586-.275 1.468-1.621.614.244",
    "data-name": "Path 14432"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m58.293 43.416-1.5 1.653-.626-.231 1.467-1.621.655.2",
    "data-name": "Path 14433"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m60.41 41.078-1.5 1.652-.667-.186 1.467-1.621.695.155",
    "data-name": "Path 14434"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m37.887 68.783-1.584 1.749-.223-.676 1.555-1.717.251.644",
    "data-name": "Path 14435"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m40.129 66.308-1.584 1.749-.263-.631 1.556-1.718z",
    "data-name": "Path 14436"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m42.37 63.832-1.584 1.749-.3-.587 1.556-1.717.332.555",
    "data-name": "Path 14437"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m44.611 61.357-1.584 1.749-.344-.543 1.556-1.718z",
    "data-name": "Path 14438"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m51.337 53.929-6.067 6.7-.384-.5 5.958-6.58.493.377",
    "data-name": "Path 14439"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m53.579 51.454-1.584 1.749-.5-.364 1.556-1.718.533.333",
    "data-name": "Path 14440"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m55.82 48.978-1.584 1.749-.545-.319 1.555-1.718z",
    "data-name": "Path 14441"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m58.061 46.503-1.584 1.749-.586-.275 1.556-1.718z",
    "data-name": "Path 14442"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m60.304 44.027-1.584 1.749-.626-.231 1.556-1.718z",
    "data-name": "Path 14443"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "M62.545 41.551 60.961 43.3l-.666-.186 1.555-1.717z",
    "data-name": "Path 14444"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m38.529 66.588-2.584 2.854-.223-.676 2.537-2.8z",
    "data-name": "Path 14445"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m40.68 64.214-1.538 1.7-.282-.611 1.509-1.667.31.579",
    "data-name": "Path 14446"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m42.856 61.811-1.538 1.7-.322-.566 1.51-1.667.35.535",
    "data-name": "Path 14447"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m45.032 59.406-1.538 1.7-.363-.522 1.511-1.668z",
    "data-name": "Path 14448"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m47.209 57.003-1.538 1.7-.4-.477 1.509-1.667.431.446",
    "data-name": "Path 14449"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m49.386 54.594-1.538 1.7-.443-.432 1.509-1.667z",
    "data-name": "Path 14450"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m51.563 52.194-1.538 1.7-.484-.388 1.51-1.667z",
    "data-name": "Path 14451"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m53.739 49.791-1.538 1.7-.524-.343 1.51-1.667.552.312",
    "data-name": "Path 14452"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m55.916 47.387-1.538 1.7-.564-.3 1.509-1.667z",
    "data-name": "Path 14453"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m58.092 44.984-1.538 1.7-.6-.254 1.509-1.667.633.223",
    "data-name": "Path 14454"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4c",
    d: "m61.425 41.302-2.717 3-.645-.21 2.666-2.945.695.154",
    "data-name": "Path 14455"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8b8b",
    d: "M65.996 51.106a1.175 1.175 0 0 1 .468 1.593l-13.36 24.476a1.175 1.175 0 0 1-1.593.468L33.79 67.971a1.175 1.175 0 0 1-.468-1.594l13.36-24.476a1.174 1.174 0 0 1 1.593-.468Z",
    "data-name": "Path 14456"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#25364f",
    d: "M65.408 51.439a1.14 1.14 0 0 1 .454 1.546L53.019 76.514a1.14 1.14 0 0 1-1.546.454l-17.094-9.331a1.14 1.14 0 0 1-.455-1.546l12.842-23.529a1.14 1.14 0 0 1 1.546-.454Z",
    "data-name": "Path 14457"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    d: "m35.473 66.476 12.455-22.818 16.27 8.88-12.456 22.818z",
    "data-name": "Rectangle 585"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "m38.926 66.281 5.568-10.207 12.582 6.864-5.568 10.207z",
    "data-name": "Rectangle 587"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m36.107 66.134 11.876-21.758 1.315.718-11.876 21.758z",
    "data-name": "Rectangle 588"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#bababa",
    d: "M41.21 54.289a.452.452 0 1 1-.613.18.45.45 0 0 1 .613-.18",
    "data-name": "Path 14458"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M46.687 54.383a1.307 1.307 0 0 1 1.775-.523 1.307 1.307 0 0 1 .52 1.773 1.306 1.306 0 0 1-1.772.522 1.305 1.305 0 0 1-.523-1.772",
    "data-name": "Rectangle 589"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.7 53.784a.04.04 0 0 0-.057.016l-.757 1.388-.076-.021a.05.05 0 0 0-.055.02l-.159.231a.05.05 0 0 0 .014.07.05.05 0 0 0 .07-.012l.139-.2.06.016a.1.1 0 0 0 .019.005l1.071.287a.164.164 0 0 0 .209-.068l.006-.01h.078a.13.13 0 0 0 .069.1.13.13 0 1 0 .125-.229.13.13 0 0 0-.126 0l-.046-.049.276-.507h.078a.13.13 0 0 0 .068.1.131.131 0 1 0 .125-.229.13.13 0 0 0-.126 0l-.046-.049.008-.015a.051.051 0 0 0-.089-.049l-.488.895c-.006.01-.021.039-.1.019l-.276-.074.547-1c.029-.054.009-.1-.046-.152s-.328-.286-.5-.427a.04.04 0 0 0-.02-.048m.032.193-.06.109-.062-.042.063-.117zm.405.549-.056.1-.084-.051.058-.106Zm-.763.107-.069.127-.067-.033.071-.13Zm-.014-.131.075-.137.064.039-.073.134Zm-.108.353-.069.126-.069-.03.07-.129Zm-.121.221-.083.153-.074-.02.089-.163Zm.026.182.075-.138.086.038-.068.125zm.127-.233.067-.122.084.041-.065.118Zm.119-.217.067-.123.082.044-.065.119Zm.246-.025.084.046-.061.111-.086-.042Zm.052-.1.067-.122.082.05-.064.119Zm-.1-.053-.082-.045.071-.13.08.048Zm.041-.27.066-.122.078.052-.065.118Zm-.094-.057-.064-.038.07-.129.063.041Zm-.191 1 .06-.11.088.039-.053.1-.1-.025m.112-.206.062-.114.087.042-.06.11Zm.248-.023.089.043-.056.1-.091-.04Zm.052-.1.059-.107.086.047-.056.1Zm.11-.2.062-.114.084.051-.06.11Zm.02-.267-.082-.05.062-.114.08.053Zm.032-.259.042-.077.075.064-.036.067Zm-.092-.061-.078-.052.054-.1.073.061Zm-.275 1.168.045-.082.091.04v.005c-.025.046-.075.052-.131.037m.619-.939-.079-.052.028-.052q.058.055.049.1",
    "data-name": "Path 14459"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#239072",
    d: "M48.384 51.275a1.306 1.306 0 0 1 1.773-.522 1.306 1.306 0 0 1 .522 1.774 1.307 1.307 0 0 1-1.774.521 1.307 1.307 0 0 1-.52-1.773",
    "data-name": "Rectangle 590"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m49.434 51.367-.178.327-.054-.03a.4.4 0 0 0-.119-.05.05.05 0 0 0-.053.034.06.06 0 0 0 0 .057.15.15 0 0 0 .061.053.17.17 0 0 0 .124.028 1.3 1.3 0 0 0 .216-.111 1.5 1.5 0 0 1 .208-.107.35.35 0 0 1 .155-.015.5.5 0 0 1 .2.069.47.47 0 0 1 .228.234.44.44 0 0 1-.015.319l.123.067-.082.15-.127-.069a.45.45 0 0 1-.225.174.45.45 0 0 1-.359-.069l-.064-.035.178-.326.08.044a1 1 0 0 0 .169.079.05.05 0 0 0 .059-.031.07.07 0 0 0 0-.061.13.13 0 0 0-.057-.052.6.6 0 0 0-.165-.071.27.27 0 0 0-.16.049 3 3 0 0 1-.249.128.4.4 0 0 1-.175.025.5.5 0 0 1-.2-.06.36.36 0 0 1-.184-.208.46.46 0 0 1 .033-.3l-.1-.057.082-.15.1.057a.4.4 0 0 1 .225-.171.37.37 0 0 1 .267.048l.06.037",
    "data-name": "Path 14460"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#643785",
    d: "M50.08 48.169a1.307 1.307 0 0 1 1.773-.521 1.307 1.307 0 0 1 .52 1.773 1.307 1.307 0 0 1-1.773.521 1.307 1.307 0 0 1-.52-1.773",
    "data-name": "Rectangle 591"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.137 51.154a.487.487 0 0 1 .194.661l-7.535 13.806a.487.487 0 0 1-.855-.467l7.535-13.806a.487.487 0 0 1 .661-.194",
    "data-name": "Path 14461"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.46 48.751a.5.5 0 1 1-.675.2.5.5 0 0 1 .675-.2",
    "data-name": "Path 14462"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.2 47.395a.5.5 0 1 1-.675.2.5.5 0 0 1 .675-.2",
    "data-name": "Path 14463"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.939 46.04a.5.5 0 1 1-.675.2.5.5 0 0 1 .675-.2",
    "data-name": "Path 14464"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M56.919 56.19a.143.143 0 0 1 .064.191l-1.753 3.211a.143.143 0 0 1-.2.049l-1.928-1.058a.143.143 0 0 1-.064-.191l1.753-3.212a.143.143 0 0 1 .2-.049Z",
    "data-name": "Path 14465"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "m52.513 57.815 1.505-2.757a.48.48 0 0 1 .652-.19.48.48 0 0 1 .192.653l-1.504 2.755a.48.48 0 0 1-.652.19.48.48 0 0 1-.193-.651",
    "data-name": "Rectangle 592"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M53.121 58.066a.14.14 0 0 1-.193.056l-.447-.243-.127.232a.14.14 0 0 0 .057.193l.594.325a.143.143 0 0 0 .194-.057l1.829-3.351a.143.143 0 0 0-.057-.193l-.148-.081Z",
    "data-name": "Path 14466"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M54.35 54.835a.08.08 0 0 1 .033.109l-1.5 2.743a.081.081 0 1 1-.141-.077l1.5-2.743a.08.08 0 0 1 .109-.032",
    "data-name": "Path 14467"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e000e",
    d: "m53.959 57.174.302-.554 1.996 1.09-.302.553z",
    "data-name": "Rectangle 593"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9225",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9224"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__y)",
    "data-name": "Group 9223",
    transform: "translate(53.959 56.619)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a4989f",
    d: "M0 .554.302 0l.166.09-.302.555z",
    "data-name": "Rectangle 594"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9228",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9227"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__z)",
    "data-name": "Group 9226",
    transform: "translate(54.512 56.922)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a4989f",
    d: "M0 .554.302 0l.69.376L.69.93z",
    "data-name": "Rectangle 596"
  }))))), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e000e",
    d: "m53.077 56.779.376-.688.844.46-.376.689z",
    "data-name": "Rectangle 598"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e000e",
    d: "M53.063 56.41c.222.121.23.534.019.921-.079.144-.443-.143-.443-.143s-.432-.1-.361-.3.563-.6.785-.483",
    "data-name": "Path 14468"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f0707",
    d: "M52.754 56.976a.76.76 0 0 1-.318.139 1 1 0 0 0 .2.073l.027.02h.016a2 2 0 0 1 .04-.157q.017-.037.033-.074",
    "data-name": "Path 14469"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f0707",
    d: "M53.164 56.675c-.02.239-.138.571-.392.607.113.069.261.136.308.05.206-.378.2-.78 0-.912.008.023-.321.154-.316.178s.227-.049.289-.04c.033 0-.026.237-.013.254.03.036.129-.168.126-.136",
    "data-name": "Path 14470"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#c10011",
    d: "M52.83 56.451c.027.035-.112.136-.236.257s-.274.258-.3.222.091-.206.229-.311.28-.2.307-.168",
    "data-name": "Path 14471"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e000e",
    d: "M53.112 56.32c.222.121.573-.095.785-.483.078-.144-.361-.3-.361-.3s-.321-.307-.443-.143-.2.8.019.921",
    "data-name": "Path 14472"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f0707",
    d: "M53.418 55.754a.76.76 0 0 0-.056-.343 1 1 0 0 1 .171.13l.032.012.007.014a2 2 0 0 0-.11.119l-.043.067",
    "data-name": "Path 14473"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f0707",
    d: "M53.39 56.263c.19-.147.405-.425.3-.658.118.058.255.146.209.232-.206.378-.546.593-.768.491.023-.006-.044-.354-.021-.362s.082.218.122.265c.022.025.185-.15.206-.147.046.006-.072.2-.047.18",
    "data-name": "Path 14474"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#c10011",
    d: "M53.02 56.101c.044 0 .054-.167.089-.337s.068-.37.024-.373-.124.188-.138.361-.02.346.025.349",
    "data-name": "Path 14475"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e000e",
    d: "M53.245 56.227c.154.084.132.122.066.244s-.112.147-.266.064-.151-.132-.084-.255.13-.137.284-.053",
    "data-name": "Path 14476"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#c10011",
    d: "M52.97 56.312a.26.26 0 0 0 .183.067c.049-.009.126-.037.132-.091v-.01a.4.4 0 0 0-.068-.046c-.124-.068-.176-.056-.229.043z",
    "data-name": "Path 14477"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c000c",
    d: "M53.218 56.483a.44.44 0 0 1-.3-.075c0 .044.041.08.127.127.154.084.2.059.266-.063l.019-.034a.3.3 0 0 1-.11.046",
    "data-name": "Path 14478"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e000e",
    d: "m53.789 58.961 1.884-3.451.554.302-1.884 3.451z",
    "data-name": "Rectangle 599"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "m49.503 57.121 4.402-8.068 1.471.803-4.401 8.068z",
    "data-name": "Rectangle 601"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "m55.616 60.457 4.402-8.068 1.471.803-4.401 8.068z",
    "data-name": "Rectangle 602"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "m54.751 53.66 1.743-3.193.736.401-1.743 3.193z",
    "data-name": "Rectangle 603"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "m55.831 54.249 1.743-3.193.736.401-1.743 3.193z",
    "data-name": "Rectangle 604"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d1d1",
    d: "m56.911 54.839 1.743-3.193.736.401-1.743 3.193z",
    "data-name": "Rectangle 605"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9231",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9230"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consumer_goods_icon_svg__A)",
    "data-name": "Group 9229",
    transform: "translate(49.543 63.273)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.466.009c.081.045.054.253-.062.466l-3 5.494c-.116.213-.277.349-.358.3s-.053-.253.062-.466l3-5.493c.116-.213.277-.349.358-.3",
    "data-name": "Path 14481"
  }))))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m50.994 47.793-.445.2-.04.453.57 1.243a.13.13 0 0 0 .184.078l.618-.283c.077-.035.092-.1.051-.186l-.569-1.244Zm-.122.321a.087.087 0 1 1 .043-.115.087.087 0 0 1-.043.115",
    "data-name": "Path 14482"
  }))))))));
};
export default SvgConsumerGoodsIcon;